import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1000 1000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,500.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="
M 0.00 1000.00 
L 1000.00 1000.00
L 1000.00 0.00
L 0.00 0.00
L 0.00 1000.00
M 712.00 242.00 
C 715.07 244.57 718.79 247.79 722.00 251.00
C 748.08 273.28 762.78 293.94 780.30 322.70 C 797.83 351.45 810.47 380.06 817.99 415.01 C 825.51 449.96 822.03 498.96 818.00 535.00
C 816.86 545.23 813.73 554.62 811.00 564.00
C 808.19 580.31 798.95 599.07 792.07 614.07 C 785.20 629.08 774.16 644.57 763.00 655.00
C 761.57 645.13 760.05 635.24 760.00 625.00
C 758.70 611.62 763.58 604.27 770.00 593.00
C 775.81 579.21 784.03 564.11 786.00 549.00
C 786.56 544.73 788.32 540.74 789.00 537.00
C 789.00 536.01 788.95 534.99 789.00 534.00
C 789.31 527.99 791.92 520.61 793.00 515.00
C 794.96 490.33 797.27 461.52 792.67 437.33 C 788.07 413.14 782.78 394.18 775.00 372.00
C 764.38 350.52 751.90 325.61 736.00 307.00
C 723.42 292.28 710.94 279.72 696.75 267.25 C 682.55 254.79 665.22 245.55 650.00 235.00
C 639.50 229.86 627.70 224.20 617.00 220.00
C 594.98 213.95 577.33 208.32 553.98 205.02 C 530.63 201.73 504.59 205.04 481.00 206.00
C 476.41 206.67 472.22 208.53 467.00 209.00
C 448.68 210.67 436.25 218.23 418.77 223.77 C 401.29 229.31 377.12 226.28 358.00 227.00
C 371.09 212.40 388.60 206.82 407.01 198.01 C 425.42 189.20 446.86 183.85 468.00 180.00 C 489.14 176.15 519.62 174.77 542.00 176.00 C 564.38 177.23 588.99 181.78 609.22 187.78 C 629.46 193.78 646.22 201.56 664.22 210.78 C 682.22 219.99 696.04 229.72 712.00 242.00
M 434.00 256.00 
C 425.94 256.64 419.45 259.52 413.25 265.25 C 407.05 270.98 404.39 277.37 403.00 286.00 C 401.61 294.63 401.97 306.31 402.00 316.00 C 402.03 325.69 401.99 336.97 402.00 347.00 C 402.01 357.03 401.99 367.82 402.00 378.00 C 402.01 388.18 401.98 398.78 402.00 409.00 C 402.02 419.22 401.97 429.82 402.00 440.00 C 402.03 450.18 401.93 460.95 402.00 471.00 C 402.07 481.05 401.85 492.27 402.00 502.00 C 402.15 511.73 401.67 524.00 402.00 533.00 C 402.33 542.00 405.91 550.27 408.31 557.69 C 410.70 565.12 417.79 570.74 423.08 573.92 C 428.37 577.10 446.13 579.78 437.00 589.00
C 432.04 594.01 418.44 588.39 411.00 590.00 C 403.56 591.61 392.27 589.25 384.00 590.00 C 375.73 590.75 365.62 589.61 357.00 590.00 C 348.38 590.39 338.72 589.71 330.00 590.00
C 332.10 593.12 334.18 596.33 335.00 600.00
C 339.01 611.13 336.26 619.19 325.92 622.92 C 315.58 626.65 307.72 636.26 299.75 628.25 C 291.79 620.23 288.63 610.15 298.25 606.25 C 307.87 602.34 314.94 597.58 324.00 593.00
C 325.07 592.09 325.92 590.80 327.00 590.00
C 316.50 589.34 304.68 591.33 295.00 589.00
C 293.28 586.54 296.29 580.76 295.00 578.00
C 326.28 573.51 329.04 543.81 329.00 515.00 C 328.96 486.19 328.77 446.78 329.00 417.00 C 329.23 387.22 328.35 348.93 329.00 320.00 C 329.65 291.07 330.53 257.27 296.00 255.00
C 293.72 253.67 292.77 247.48 294.00 245.00
C 296.38 240.19 305.68 243.80 311.00 243.00 C 316.32 242.20 324.98 243.35 331.00 243.00 C 337.02 242.65 344.72 243.12 351.00 243.00 C 357.28 242.88 363.59 242.95 370.00 243.00 C 376.41 243.05 383.55 242.78 390.00 243.00 C 396.45 243.22 403.64 242.46 410.00 243.00 C 416.36 243.54 422.87 241.71 429.00 243.00 C 435.13 244.29 443.42 238.58 444.99 247.01 C 446.57 255.44 441.02 255.44 434.00 256.00
M 478.00 504.00 
C 475.57 502.54 476.64 505.12 474.00 505.00
C 476.63 497.65 466.54 492.85 465.00 486.00
C 459.38 476.33 449.34 466.42 444.08 456.92 C 438.83 447.42 423.01 437.19 430.00 427.00
C 442.59 408.65 458.92 393.14 473.00 376.00
C 476.97 370.32 481.56 364.75 486.25 359.25 C 490.93 353.75 494.31 347.73 499.30 342.30 C 504.30 336.87 507.23 330.99 512.25 325.25 C 517.28 319.51 518.66 313.42 521.92 306.92 C 525.19 300.43 529.88 291.57 529.93 283.93 C 529.97 276.28 529.19 266.74 521.10 262.90 C 513.01 259.06 509.83 255.80 498.93 255.07 C 488.03 254.34 489.81 242.11 502.00 244.00 C 514.19 245.89 521.91 243.11 533.00 244.00 C 544.09 244.89 552.48 243.60 563.00 244.00 C 573.52 244.40 582.71 243.81 593.00 244.00 C 603.29 244.19 612.74 243.91 623.00 244.00 C 633.26 244.09 643.72 243.93 654.00 244.00
C 658.68 257.91 643.27 254.89 634.99 255.99 C 626.71 257.09 617.83 259.80 610.77 263.77 C 603.72 267.74 597.16 270.30 590.97 274.97 C 584.78 279.65 578.99 284.22 573.25 289.25 C 567.51 294.28 563.11 299.50 557.25 304.25 C 551.39 309.00 546.87 315.47 541.75 320.75 C 536.63 326.03 531.32 331.13 526.75 336.75 C 522.19 342.37 516.14 348.13 511.75 353.75 C 507.37 359.38 501.26 365.12 498.08 371.08 C 494.91 377.04 484.15 382.21 484.08 389.08 C 484.00 395.94 494.43 401.52 497.25 407.75 C 500.08 413.97 507.07 419.09 510.75 425.25 C 514.44 431.41 520.33 437.53 524.30 443.70 C 528.28 449.86 534.17 454.75 537.75 461.25 C 541.34 467.74 547.68 472.97 551.75 479.25 C 555.82 485.53 560.07 491.18 564.75 497.25 C 569.43 503.31 573.90 509.65 578.90 515.10 C 583.90 520.56 586.44 527.58 591.75 533.25 C 597.06 538.91 600.30 545.31 605.75 551.25 C 611.20 557.18 615.89 560.67 622.23 565.77 C 628.57 570.87 638.08 571.12 645.02 574.98 C 651.96 578.83 668.01 572.98 669.99 582.01 C 671.97 591.03 654.53 589.38 646.00 589.00 C 637.47 588.62 623.25 589.22 614.00 589.00 C 604.75 588.78 592.17 589.19 583.00 589.00 C 573.83 588.81 562.89 587.69 554.93 585.07 C 546.96 582.45 540.97 578.96 534.77 574.23 C 528.57 569.51 523.21 564.59 518.25 558.75 C 513.28 552.92 508.99 547.73 504.25 541.75 C 499.50 535.77 496.28 528.52 491.25 522.75 C 486.21 516.98 482.78 509.98 478.00 504.00
M 258.00 553.00 
C 259.14 555.95 260.97 559.46 262.00 563.00
C 266.45 578.28 273.43 593.47 280.31 607.69 C 287.19 621.92 298.32 632.36 306.00 646.00
C 307.89 648.46 310.58 650.98 313.00 653.00
C 314.64 649.18 305.71 643.77 314.00 642.00
C 323.93 636.52 333.86 629.92 344.00 625.00
C 349.43 622.37 360.04 631.79 357.22 638.22 C 354.40 644.65 345.08 648.82 341.25 654.25 C 337.42 659.67 330.88 669.18 325.00 666.00
C 326.96 670.13 335.25 679.77 338.00 677.00
C 342.77 673.48 347.64 666.36 352.00 662.00
C 354.44 659.14 356.93 656.14 360.00 654.00
C 360.20 653.60 360.00 653.00 360.00 653.00
C 353.21 648.26 359.46 640.04 365.25 643.76 C 371.03 647.47 373.34 651.48 378.75 656.25 C 384.16 661.01 373.63 669.89 369.00 663.00
C 361.94 671.69 353.00 680.06 346.00 688.00
C 352.02 688.00 354.31 693.99 359.00 697.00
C 363.15 690.54 369.00 684.17 375.00 679.00
C 380.48 671.32 384.46 661.78 394.23 666.77 C 404.00 671.76 400.05 680.55 395.08 689.08 C 390.10 697.60 388.03 705.99 382.00 713.00
C 387.67 715.01 392.22 719.42 398.00 721.00
C 399.99 721.89 402.01 722.85 404.00 724.00
C 403.70 722.43 404.25 720.40 406.00 720.00
C 412.36 708.56 414.07 694.66 420.00 683.00
C 427.86 684.15 442.42 687.48 441.00 698.00 C 439.58 708.52 433.67 717.83 422.00 713.00
C 421.55 717.28 419.16 720.93 418.00 725.00
C 417.40 726.26 417.41 728.63 415.00 728.00
C 415.24 729.67 417.85 728.17 418.00 730.00
C 426.24 737.49 440.60 738.73 451.69 742.31 C 462.79 745.89 479.03 749.05 491.00 750.00
C 495.90 750.39 501.77 750.59 506.00 751.00
C 517.33 751.00 528.67 751.00 540.00 751.00
C 552.02 749.84 565.62 744.67 578.00 745.00
C 578.98 745.03 580.03 745.08 581.00 745.00
C 585.89 743.68 593.08 740.94 597.00 740.00
C 622.11 733.98 650.19 737.25 676.00 733.00
C 671.66 743.37 659.03 746.24 648.75 751.75 C 638.48 757.27 625.55 760.00 614.33 764.33 C 603.11 768.66 589.25 772.14 577.00 774.00
C 571.63 775.33 565.98 776.33 560.00 777.00
C 546.47 778.51 530.86 779.67 517.00 779.00 C 503.14 778.33 487.01 778.22 474.00 776.00 C 460.99 773.78 449.06 770.98 437.00 768.00 C 424.94 765.03 414.95 758.93 403.78 755.22 C 392.60 751.51 383.68 745.52 373.31 740.70 C 362.93 735.87 355.29 726.52 345.00 725.00
C 344.06 719.05 336.20 716.83 332.00 713.00
C 319.54 702.97 306.91 690.77 296.00 678.00
C 292.89 675.18 289.62 672.74 287.00 669.00
C 282.91 663.15 272.21 653.06 271.00 646.00
C 270.92 645.51 271.15 644.45 271.00 644.00
C 266.58 638.28 260.85 629.46 256.00 627.00
C 258.28 620.81 251.25 616.11 250.00 610.00
C 245.99 600.36 240.24 590.28 238.00 580.00
C 236.01 574.39 233.43 568.46 232.00 562.00
C 231.24 558.56 230.19 555.34 229.00 552.00
C 227.35 547.35 226.97 542.19 226.00 537.00
C 224.02 526.37 222.99 517.30 222.00 506.00
C 220.98 500.73 220.00 495.27 220.00 489.00
C 220.00 481.67 220.00 474.33 220.00 467.00
C 220.00 456.60 221.86 447.39 223.00 438.00
C 223.27 424.27 226.63 406.93 230.33 394.33 C 234.03 381.73 240.27 369.46 244.78 357.78 C 249.28 346.10 256.09 334.23 261.92 323.92 C 267.75 313.60 275.02 301.20 282.75 293.75 C 290.48 286.31 297.71 265.23 307.90 276.10 C 318.09 286.97 310.34 303.97 302.25 313.25 C 294.15 322.53 289.22 333.88 282.68 344.68 C 276.14 355.48 270.37 366.37 266.03 379.03 C 261.68 391.68 257.23 403.56 253.08 417.08 C 248.92 430.59 250.57 448.13 248.00 463.00 C 245.43 477.87 248.86 495.20 249.93 510.07 C 250.99 524.94 254.41 538.94 258.00 553.00
M 641.00 367.00 
C 660.05 367.00 678.55 368.66 696.08 372.92 C 713.61 377.18 723.84 380.79 739.75 390.25 C 755.65 399.72 746.00 422.22 746.00 439.00
C 746.00 445.13 744.64 450.73 744.00 456.00
C 743.73 463.13 744.06 478.89 735.00 476.00 C 725.94 473.11 726.71 465.44 724.00 458.00
C 717.51 445.85 710.96 432.60 703.00 421.00
C 697.12 412.42 690.56 404.74 682.25 397.75 C 673.93 390.76 663.78 386.81 653.32 382.68 C 642.86 378.54 624.75 378.34 613.00 379.00 C 601.25 379.66 589.14 382.95 579.92 389.92 C 570.70 396.89 565.73 404.60 560.70 414.70 C 555.66 424.79 553.02 436.88 550.22 448.22 C 547.42 459.56 535.43 442.32 531.25 434.75 C 527.06 427.19 515.31 418.80 512.25 409.75 C 509.18 400.70 525.56 394.63 533.23 389.23 C 540.90 383.83 553.82 378.71 564.00 376.00 C 574.18 373.29 588.31 368.00 600.00 368.00
C 613.14 366.73 627.68 365.71 641.00 367.00
M 553.00 651.00 
C 555.09 657.19 558.76 664.28 561.00 671.00
C 563.83 679.49 568.35 684.53 574.75 691.25 C 581.15 697.97 587.37 701.57 596.07 704.93 C 604.78 708.28 617.14 709.45 627.00 709.00 C 636.86 708.55 647.58 706.41 656.22 703.22 C 664.86 700.03 671.82 695.82 679.08 691.08 C 686.34 686.35 692.52 681.67 698.25 675.25 C 703.98 668.82 708.97 662.12 713.25 655.25 C 717.54 648.39 722.48 638.92 724.92 631.92 C 727.37 624.93 729.66 607.63 739.00 611.00 C 748.34 614.37 743.56 630.78 745.00 640.00 C 746.44 649.22 748.00 662.32 748.00 672.00
C 748.43 676.46 751.48 685.81 749.22 690.22 C 746.96 694.63 739.84 696.40 736.00 698.00
C 683.06 727.50 604.63 727.83 549.00 706.00
C 543.53 703.85 538.34 701.39 533.00 699.00
C 535.34 704.31 537.01 713.08 529.00 713.00
C 531.35 713.26 535.07 711.97 536.00 715.00
C 539.39 720.83 535.24 724.92 537.99 732.01 C 540.75 739.09 530.89 736.65 527.25 738.26 C 523.62 739.87 516.86 741.38 513.25 736.75 C 509.64 732.12 510.08 727.58 509.01 721.99 C 507.94 716.41 507.07 710.89 507.00 705.00 C 506.93 699.11 512.19 696.19 517.00 695.00
C 519.15 694.47 523.05 694.13 525.00 693.00
C 518.10 689.62 512.28 684.07 507.00 678.00
C 493.94 666.84 481.82 651.93 475.00 637.00
C 472.09 632.20 469.18 627.45 467.00 622.00
C 466.83 621.57 467.00 621.00 467.00 621.00
C 465.07 617.31 462.84 613.33 462.00 609.00
C 460.19 599.64 457.18 590.95 455.67 581.33 C 454.16 571.71 451.32 560.06 452.00 550.00 C 452.68 539.94 451.54 525.80 453.00 517.00 C 454.46 508.20 456.85 491.65 462.77 500.23 C 468.69 508.81 471.42 512.82 476.75 520.25 C 482.09 527.67 485.59 534.08 491.25 540.75 C 496.91 547.42 499.69 553.85 506.25 559.75 C 512.80 565.65 516.48 572.53 523.08 577.92 C 529.68 583.30 536.24 588.90 544.00 592.00
C 544.70 612.26 548.75 631.63 553.00 651.00
M 454.00 728.00 
C 460.95 727.96 460.62 734.27 458.00 739.00
C 453.65 736.98 439.88 739.70 440.01 732.99 C 440.14 726.28 443.13 719.64 443.98 712.98 C 444.82 706.31 447.81 699.90 448.00 693.00
C 458.02 690.99 462.97 696.70 459.02 705.02 C 455.08 713.35 456.16 719.47 454.00 728.00
M 484.00 697.00 
C 485.34 709.08 480.97 721.72 484.00 733.00
C 484.63 725.49 486.21 719.25 486.00 711.00 C 485.78 702.74 486.18 694.15 498.00 698.00
C 494.82 711.31 505.67 742.26 484.00 742.00 C 462.33 741.73 473.50 710.51 472.00 697.00
C 476.00 697.00 480.00 697.00 484.00 697.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#F09920" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 467.00 209.00 
C 471.71 208.02 475.59 206.22 481.00 206.00
C 504.59 205.04 530.63 201.73 553.98 205.02 C 577.33 208.32 594.98 213.95 617.00 220.00
C 628.02 223.03 640.66 228.53 650.00 235.00
C 665.22 245.55 682.55 254.79 696.75 267.25 C 710.94 279.72 723.42 292.28 736.00 307.00
C 752.82 323.82 767.29 350.03 775.00 372.00
C 782.78 394.18 788.07 413.14 792.67 437.33 C 797.27 461.52 794.96 490.33 793.00 515.00
C 792.43 522.21 790.42 527.74 789.00 534.00
C 788.95 534.99 789.00 536.01 789.00 537.00
C 789.02 541.49 786.89 545.18 786.00 549.00
C 784.03 564.11 775.81 579.21 770.00 593.00
C 765.16 604.47 760.00 611.67 760.00 625.00
C 760.05 635.24 761.57 645.13 763.00 655.00
C 774.16 644.57 785.20 629.08 792.07 614.07 C 798.95 599.07 808.19 580.31 811.00 564.00
C 812.70 554.13 815.82 544.38 818.00 535.00
C 822.03 498.96 825.51 449.96 817.99 415.01 C 810.47 380.06 797.83 351.45 780.30 322.70 C 762.78 293.94 748.08 273.28 722.00 251.00
C 718.48 247.99 715.22 245.22 712.00 242.00
C 696.04 229.72 682.22 219.99 664.22 210.78 C 646.22 201.56 629.46 193.78 609.22 187.78 C 588.99 181.78 564.38 177.23 542.00 176.00 C 519.62 174.77 489.14 176.15 468.00 180.00 C 446.86 183.85 425.42 189.20 407.01 198.01 C 388.60 206.82 371.09 212.40 358.00 227.00
C 377.12 226.28 401.29 229.31 418.77 223.77 C 436.25 218.23 448.68 210.67 467.00 209.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#F7D49D" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 467.00 209.00 
C 472.22 208.53 476.41 206.67 481.00 206.00
C 475.59 206.22 471.71 208.02 467.00 209.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#F6CE93" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 650.00 235.00 
C 640.66 228.53 628.02 223.03 617.00 220.00
C 627.70 224.20 639.50 229.86 650.00 235.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#FEF0D4" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 722.00 251.00 
C 718.79 247.79 715.07 244.57 712.00 242.00
C 715.22 245.22 718.48 247.99 722.00 251.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#FAF2DD" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 294.00 245.00 
C 296.97 240.80 307.68 245.19 313.00 244.00 C 318.32 242.81 327.88 244.60 334.00 244.00 C 340.12 243.40 347.47 244.34 354.00 244.00 C 360.53 243.66 368.32 244.33 375.00 244.00 C 381.68 243.67 388.26 244.56 395.00 244.00 C 401.74 243.44 409.26 245.10 416.00 244.00 C 422.74 242.90 429.35 246.52 436.00 244.00 C 442.65 241.48 448.57 251.75 442.00 255.00
C 440.58 255.70 435.29 255.75 434.00 256.00
C 441.02 255.44 446.57 255.44 444.99 247.01 C 443.42 238.58 435.13 244.29 429.00 243.00 C 422.87 241.71 416.36 243.54 410.00 243.00 C 403.64 242.46 396.45 243.22 390.00 243.00 C 383.55 242.78 376.41 243.05 370.00 243.00 C 363.59 242.95 357.28 242.88 351.00 243.00 C 344.72 243.12 337.02 242.65 331.00 243.00 C 324.98 243.35 316.32 242.20 311.00 243.00 C 305.68 243.80 296.38 240.19 294.00 245.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#F1B763" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 294.00 245.00 
C 292.77 247.48 293.72 253.67 296.00 255.00
C 293.44 252.90 295.88 247.69 295.00 245.00
C 344.33 245.00 393.67 245.00 443.00 245.00
C 442.68 248.34 443.84 252.07 442.00 255.00
C 448.57 251.75 442.65 241.48 436.00 244.00 C 429.35 246.52 422.74 242.90 416.00 244.00 C 409.26 245.10 401.74 243.44 395.00 244.00 C 388.26 244.56 381.68 243.67 375.00 244.00 C 368.32 244.33 360.53 243.66 354.00 244.00 C 347.47 244.34 340.12 243.40 334.00 244.00 C 327.88 244.60 318.32 242.81 313.00 244.00 C 307.68 245.19 296.97 240.80 294.00 245.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#EF981D" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 473.00 376.00 
C 460.38 394.02 444.25 410.49 430.00 427.00
C 423.01 437.19 438.83 447.42 444.08 456.92 C 449.34 466.42 459.38 476.33 465.00 486.00
C 469.48 491.74 473.93 497.69 478.00 504.00
C 482.78 509.98 486.21 516.98 491.25 522.75 C 496.28 528.52 499.50 535.77 504.25 541.75 C 508.99 547.73 513.28 552.92 518.25 558.75 C 523.21 564.59 528.57 569.51 534.77 574.23 C 540.97 578.96 546.96 582.45 554.93 585.07 C 562.89 587.69 573.83 588.81 583.00 589.00 C 592.17 589.19 604.75 588.78 614.00 589.00 C 623.25 589.22 637.47 588.62 646.00 589.00 C 654.53 589.38 671.97 591.03 669.99 582.01 C 668.01 572.98 651.96 578.83 645.02 574.98 C 638.08 571.12 628.57 570.87 622.23 565.77 C 615.89 560.67 611.20 557.18 605.75 551.25 C 600.30 545.31 597.06 538.91 591.75 533.25 C 586.44 527.58 583.90 520.56 578.90 515.10 C 573.90 509.65 569.43 503.31 564.75 497.25 C 560.07 491.18 555.82 485.53 551.75 479.25 C 547.68 472.97 541.34 467.74 537.75 461.25 C 534.17 454.75 528.28 449.86 524.30 443.70 C 520.33 437.53 514.44 431.41 510.75 425.25 C 507.07 419.09 500.08 413.97 497.25 407.75 C 494.43 401.52 484.00 395.94 484.08 389.08 C 484.15 382.21 494.91 377.04 498.08 371.08 C 501.26 365.12 507.37 359.38 511.75 353.75 C 516.14 348.13 522.19 342.37 526.75 336.75 C 531.32 331.13 536.63 326.03 541.75 320.75 C 546.87 315.47 551.39 309.00 557.25 304.25 C 563.11 299.50 567.51 294.28 573.25 289.25 C 578.99 284.22 584.78 279.65 590.97 274.97 C 597.16 270.30 603.72 267.74 610.77 263.77 C 617.83 259.80 626.71 257.09 634.99 255.99 C 643.27 254.89 658.68 257.91 654.00 244.00
C 643.72 243.93 633.26 244.09 623.00 244.00 C 612.74 243.91 603.29 244.19 593.00 244.00 C 582.71 243.81 573.52 244.40 563.00 244.00 C 552.48 243.60 544.09 244.89 533.00 244.00 C 521.91 243.11 514.19 245.89 502.00 244.00 C 489.81 242.11 488.03 254.34 498.93 255.07 C 509.83 255.80 513.01 259.06 521.10 262.90 C 529.19 266.74 529.97 276.28 529.93 283.93 C 529.88 291.57 525.19 300.43 521.92 306.92 C 518.66 313.42 517.28 319.51 512.25 325.25 C 507.23 330.99 504.30 336.87 499.30 342.30 C 494.31 347.73 490.93 353.75 486.25 359.25 C 481.56 364.75 476.97 370.32 473.00 376.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#EF9719" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 296.00 255.00 
C 330.53 257.27 329.65 291.07 329.00 320.00 C 328.35 348.93 329.23 387.22 329.00 417.00 C 328.77 446.78 328.96 486.19 329.00 515.00 C 329.04 543.81 326.28 573.51 295.00 578.00
C 296.29 580.76 293.28 586.54 295.00 589.00
C 301.67 588.97 308.33 589.03 315.00 589.00 C 321.67 588.97 328.33 589.07 335.00 589.00 C 341.67 588.93 348.32 589.14 355.00 589.00 C 361.68 588.86 369.41 589.30 376.00 589.00 C 382.59 588.70 389.71 589.69 396.00 589.00 C 402.29 588.31 410.26 590.54 416.00 589.00 C 421.74 587.46 432.42 592.24 437.00 589.00
C 446.13 579.78 428.37 577.10 423.08 573.92 C 417.79 570.74 410.70 565.12 408.31 557.69 C 405.91 550.27 402.33 542.00 402.00 533.00 C 401.67 524.00 402.15 511.73 402.00 502.00 C 401.85 492.27 402.07 481.05 402.00 471.00 C 401.93 460.95 402.03 450.18 402.00 440.00 C 401.97 429.82 402.02 419.22 402.00 409.00 C 401.98 398.78 402.01 388.18 402.00 378.00 C 401.99 367.82 402.01 357.03 402.00 347.00 C 401.99 336.97 402.03 325.69 402.00 316.00 C 401.97 306.31 401.61 294.63 403.00 286.00 C 404.39 277.37 407.05 270.98 413.25 265.25 C 419.45 259.52 425.94 256.64 434.00 256.00
C 435.29 255.75 440.58 255.70 442.00 255.00
C 443.84 252.07 442.68 248.34 443.00 245.00
C 393.67 245.00 344.33 245.00 295.00 245.00
C 295.88 247.69 293.44 252.90 296.00 255.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#EF981F" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 223.00 438.00 
C 222.80 447.83 220.91 457.65 220.00 467.00
C 220.00 474.33 220.00 481.67 220.00 489.00
C 220.48 493.97 221.53 500.66 222.00 506.00
C 222.99 517.30 224.02 526.37 226.00 537.00
C 227.39 541.64 227.83 546.96 229.00 552.00
C 230.19 555.34 231.24 558.56 232.00 562.00
C 234.04 567.75 236.63 573.73 238.00 580.00
C 240.24 590.28 245.99 600.36 250.00 610.00
C 253.15 615.20 257.84 620.93 259.97 627.03 C 262.10 633.12 268.94 638.03 271.00 644.00
C 271.15 644.45 270.92 645.51 271.00 646.00
C 289.70 669.34 311.00 692.00 332.00 713.00
C 336.20 716.83 344.06 719.05 345.00 725.00
C 355.29 726.52 362.93 735.87 373.31 740.70 C 383.68 745.52 392.60 751.51 403.78 755.22 C 414.95 758.93 424.94 765.03 437.00 768.00 C 449.06 770.98 460.99 773.78 474.00 776.00 C 487.01 778.22 503.14 778.33 517.00 779.00 C 530.86 779.67 546.47 778.51 560.00 777.00
C 565.29 775.90 571.20 774.83 577.00 774.00
C 589.25 772.14 603.11 768.66 614.33 764.33 C 625.55 760.00 638.48 757.27 648.75 751.75 C 659.03 746.24 671.66 743.37 676.00 733.00
C 650.19 737.25 622.11 733.98 597.00 740.00
C 591.78 742.64 587.33 744.47 581.00 745.00
C 580.03 745.08 578.98 745.03 578.00 745.00
C 565.71 747.22 553.36 751.00 540.00 751.00
C 528.67 751.00 517.33 751.00 506.00 751.00
C 500.85 751.00 495.43 750.86 491.00 750.00
C 479.03 749.05 462.79 745.89 451.69 742.31 C 440.60 738.73 426.24 737.49 418.00 730.00
C 411.31 726.84 404.47 724.92 398.00 721.00
C 392.22 719.42 387.67 715.01 382.00 713.00
C 388.03 705.99 390.10 697.60 395.08 689.08 C 400.05 680.55 404.00 671.76 394.23 666.77 C 384.46 661.78 380.48 671.32 375.00 679.00
C 370.50 685.29 363.83 690.55 360.00 697.00
C 363.64 698.56 366.38 701.46 370.00 703.00
C 372.08 700.65 373.14 696.96 377.00 698.00
C 377.53 700.46 376.42 703.13 374.00 704.00
C 373.84 707.84 379.01 707.76 380.00 711.00
C 351.31 695.76 325.29 671.72 306.00 646.00
C 298.32 632.36 287.19 621.92 280.31 607.69 C 273.43 593.47 266.45 578.28 262.00 563.00
C 260.61 559.63 258.98 556.84 258.00 553.00
C 254.41 538.94 250.99 524.94 249.93 510.07 C 248.86 495.20 245.43 477.87 248.00 463.00 C 250.57 448.13 248.92 430.59 253.08 417.08 C 257.23 403.56 261.68 391.68 266.03 379.03 C 270.37 366.37 276.14 355.48 282.68 344.68 C 289.22 333.88 294.15 322.53 302.25 313.25 C 310.34 303.97 318.09 286.97 307.90 276.10 C 297.71 265.23 290.48 286.31 282.75 293.75 C 275.02 301.20 267.75 313.60 261.92 323.92 C 256.09 334.23 249.28 346.10 244.78 357.78 C 240.27 369.46 234.03 381.73 230.33 394.33 C 226.63 406.93 223.27 424.27 223.00 438.00
M 386.00 683.00 
C 385.13 685.99 383.82 690.71 380.00 691.00
C 380.83 687.92 383.11 684.69 386.00 683.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#F7D197" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 775.00 372.00 
C 767.29 350.03 752.82 323.82 736.00 307.00
C 751.90 325.61 764.38 350.52 775.00 372.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#F2C683" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 600.00 368.00 
C 613.62 368.00 627.13 367.00 641.00 367.00
C 627.68 365.71 613.14 366.73 600.00 368.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#F09922" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 600.00 368.00 
C 588.31 368.00 574.18 373.29 564.00 376.00 C 553.82 378.71 540.90 383.83 533.23 389.23 C 525.56 394.63 509.18 400.70 512.25 409.75 C 515.31 418.80 527.06 427.19 531.25 434.75 C 535.43 442.32 547.42 459.56 550.22 448.22 C 553.02 436.88 555.66 424.79 560.70 414.70 C 565.73 404.60 570.70 396.89 579.92 389.92 C 589.14 382.95 601.25 379.66 613.00 379.00 C 624.75 378.34 642.86 378.54 653.32 382.68 C 663.78 386.81 673.93 390.76 682.25 397.75 C 690.56 404.74 697.12 412.42 703.00 421.00
C 711.97 431.39 719.31 445.14 724.00 458.00
C 726.71 465.44 725.94 473.11 735.00 476.00 C 744.06 478.89 743.73 463.13 744.00 456.00
C 744.22 450.36 745.51 444.07 746.00 439.00
C 746.00 422.22 755.65 399.72 739.75 390.25 C 723.84 380.79 713.61 377.18 696.08 372.92 C 678.55 368.66 660.05 367.00 641.00 367.00
C 627.13 367.00 613.62 368.00 600.00 368.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#F5C887" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 430.00 427.00 
C 444.25 410.49 460.38 394.02 473.00 376.00
C 458.92 393.14 442.59 408.65 430.00 427.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#F7D39B" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 724.00 458.00 
C 719.31 445.14 711.97 431.39 703.00 421.00
C 710.96 432.60 717.51 445.85 724.00 458.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#F4C784" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 220.00 467.00 
C 220.91 457.65 222.80 447.83 223.00 438.00
C 221.86 447.39 220.00 456.60 220.00 467.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#F7CA89" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 744.00 456.00 
C 744.64 450.73 746.00 445.13 746.00 439.00
C 745.51 444.07 744.22 450.36 744.00 456.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#FDF1D9" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 478.00 504.00 
C 473.93 497.69 469.48 491.74 465.00 486.00
C 466.54 492.85 476.63 497.65 474.00 505.00
C 476.64 505.12 475.57 502.54 478.00 504.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#F6CE93" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 222.00 506.00 
C 221.53 500.66 220.48 493.97 220.00 489.00
C 220.00 495.27 220.98 500.73 222.00 506.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#EF981C" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 462.00 609.00 
C 463.17 612.85 466.91 616.43 467.00 621.00
C 467.00 621.00 466.83 621.57 467.00 622.00
C 470.76 625.84 472.73 632.04 475.00 637.00
C 481.82 651.93 493.94 666.84 507.00 678.00
C 520.25 689.32 534.19 698.09 549.00 706.00
C 604.63 727.83 683.06 727.50 736.00 698.00
C 738.98 696.34 746.38 693.67 748.23 690.23 C 750.08 686.79 748.00 676.56 748.00 672.00
C 748.00 662.32 746.44 649.22 745.00 640.00 C 743.56 630.78 748.34 614.37 739.00 611.00 C 729.66 607.63 727.37 624.93 724.92 631.92 C 722.48 638.92 717.54 648.39 713.25 655.25 C 708.97 662.12 703.98 668.82 698.25 675.25 C 692.52 681.67 686.34 686.35 679.08 691.08 C 671.82 695.82 664.86 700.03 656.22 703.22 C 647.58 706.41 636.86 708.55 627.00 709.00 C 617.14 709.45 604.78 708.28 596.07 704.93 C 587.37 701.57 581.15 697.97 574.75 691.25 C 568.35 684.53 563.83 679.49 561.00 671.00
C 557.63 664.82 554.63 658.35 553.00 651.00
C 548.75 631.63 544.70 612.26 544.00 592.00
C 536.24 588.90 529.68 583.30 523.08 577.92 C 516.48 572.53 512.80 565.65 506.25 559.75 C 499.69 553.85 496.91 547.42 491.25 540.75 C 485.59 534.08 482.09 527.67 476.75 520.25 C 471.42 512.82 468.69 508.81 462.77 500.23 C 456.85 491.65 454.46 508.20 453.00 517.00 C 451.54 525.80 452.68 539.94 452.00 550.00 C 451.32 560.06 454.16 571.71 455.67 581.33 C 457.18 590.95 460.19 599.64 462.00 609.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#F8D299" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 789.00 534.00 
C 790.42 527.74 792.43 522.21 793.00 515.00
C 791.92 520.61 789.31 527.99 789.00 534.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#F6D096" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 811.00 564.00 
C 813.73 554.62 816.86 545.23 818.00 535.00
C 815.82 544.38 812.70 554.13 811.00 564.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#F8D196" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 229.00 552.00 
C 227.83 546.96 227.39 541.64 226.00 537.00
C 226.97 542.19 227.35 547.35 229.00 552.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#F7D299" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 786.00 549.00 
C 786.89 545.18 789.02 541.49 789.00 537.00
C 788.32 540.74 786.56 544.73 786.00 549.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#F9D399" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 262.00 563.00 
C 260.97 559.46 259.14 555.95 258.00 553.00
C 258.98 556.84 260.61 559.63 262.00 563.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#F8D29A" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 238.00 580.00 
C 236.63 573.73 234.04 567.75 232.00 562.00
C 233.43 568.46 236.01 574.39 238.00 580.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#FDFAE7" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 324.00 593.00 
C 330.60 589.66 332.24 594.42 335.00 600.00
C 334.18 596.33 332.10 593.12 330.00 590.00
C 338.72 589.71 348.38 590.39 357.00 590.00 C 365.62 589.61 375.73 590.75 384.00 590.00 C 392.27 589.25 403.56 591.61 411.00 590.00 C 418.44 588.39 432.04 594.01 437.00 589.00
C 432.42 592.24 421.74 587.46 416.00 589.00 C 410.26 590.54 402.29 588.31 396.00 589.00 C 389.71 589.69 382.59 588.70 376.00 589.00 C 369.41 589.30 361.68 588.86 355.00 589.00 C 348.32 589.14 341.67 588.93 335.00 589.00 C 328.33 589.07 321.67 588.97 315.00 589.00 C 308.33 589.03 301.67 588.97 295.00 589.00
C 304.68 591.33 316.50 589.34 327.00 590.00
C 325.92 590.80 325.07 592.09 324.00 593.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#EF9B27" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 324.00 593.00 
C 314.94 597.58 307.87 602.34 298.25 606.25 C 288.63 610.15 291.79 620.23 299.75 628.25 C 307.72 636.26 315.58 626.65 325.92 622.92 C 336.26 619.19 339.01 611.13 335.00 600.00
C 332.24 594.42 330.60 589.66 324.00 593.00
M 328.00 606.00 
C 323.10 612.63 312.55 615.17 305.00 619.00
C 310.14 612.72 320.25 609.09 328.00 606.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#F6D096" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 760.00 625.00 
C 760.00 611.67 765.16 604.47 770.00 593.00
C 763.58 604.27 758.70 611.62 760.00 625.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#FAE8C7" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 328.00 606.00 
C 320.25 609.09 310.14 612.72 305.00 619.00
C 312.55 615.17 323.10 612.63 328.00 606.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#F8D39C" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 467.00 621.00 
C 466.91 616.43 463.17 612.85 462.00 609.00
C 462.84 613.33 465.07 617.31 467.00 621.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#F7D19A" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 271.00 644.00 
C 268.94 638.03 262.10 633.12 259.97 627.03 C 257.84 620.93 253.15 615.20 250.00 610.00
C 251.25 616.11 258.28 620.81 256.00 627.00
C 260.85 629.46 266.58 638.28 271.00 644.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#F9D7A0" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 475.00 637.00 
C 472.73 632.04 470.76 625.84 467.00 622.00
C 469.18 627.45 472.09 632.20 475.00 637.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#F4C988" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 344.00 625.00 
C 349.93 623.23 360.42 633.98 354.75 639.75 C 349.08 645.52 344.11 650.52 338.25 656.25 C 332.38 661.98 328.15 671.29 322.00 661.00
C 323.02 661.59 315.08 659.82 315.00 656.00
C 315.96 654.17 319.63 655.83 320.00 653.00
C 316.15 652.94 311.69 649.02 311.00 644.00
C 312.28 644.27 313.72 643.23 314.00 642.00
C 305.71 643.77 314.64 649.18 313.00 653.00
C 310.58 650.98 307.89 648.46 306.00 646.00
C 325.29 671.72 351.31 695.76 380.00 711.00
C 379.01 707.76 373.84 707.84 374.00 704.00
C 376.42 703.13 377.53 700.46 377.00 698.00
C 373.14 696.96 372.08 700.65 370.00 703.00
C 366.38 701.46 363.64 698.56 360.00 697.00
C 363.83 690.55 370.50 685.29 375.00 679.00
C 369.00 684.17 363.15 690.54 359.00 697.00
C 354.31 693.99 352.02 688.00 346.00 688.00
C 353.00 680.06 361.94 671.69 369.00 663.00
C 373.63 669.89 384.16 661.01 378.75 656.25 C 373.34 651.48 371.03 647.47 365.25 643.76 C 359.46 640.04 353.21 648.26 360.00 653.00
C 355.61 647.26 360.38 640.59 365.75 645.25 C 371.12 649.90 373.06 652.14 378.25 656.75 C 383.44 661.37 372.49 668.33 369.00 662.00
C 364.58 668.10 359.32 670.73 355.23 677.23 C 351.14 683.73 343.77 687.38 339.00 679.00
C 344.71 670.08 353.24 662.45 360.00 654.00
C 356.93 656.14 354.44 659.14 352.00 662.00
C 347.91 666.79 343.37 673.81 338.00 677.00
C 335.25 679.77 326.96 670.13 325.00 666.00
C 330.88 669.18 337.42 659.67 341.25 654.25 C 345.08 648.82 354.40 644.65 357.22 638.22 C 360.04 631.79 349.43 622.37 344.00 625.00
M 376.00 699.00 
C 375.39 701.65 373.81 705.49 371.00 706.00
C 368.60 703.14 373.39 699.41 376.00 699.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#EF981F" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 344.00 625.00 
C 333.86 629.92 323.93 636.52 314.00 642.00
C 313.72 643.23 312.28 644.27 311.00 644.00
C 311.69 649.02 316.15 652.94 320.00 653.00
C 321.76 653.03 323.07 651.49 325.00 652.00
C 324.84 654.64 321.98 656.62 320.00 658.00
C 320.30 659.25 321.83 659.71 322.00 661.00
C 328.15 671.29 332.38 661.98 338.25 656.25 C 344.11 650.52 349.08 645.52 354.75 639.75 C 360.42 633.98 349.93 623.23 344.00 625.00
M 337.00 642.00 
C 336.83 644.27 333.65 645.48 332.00 647.00
C 329.78 643.98 335.30 643.38 337.00 642.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#FAE3B6" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 337.00 642.00 
C 335.30 643.38 329.78 643.98 332.00 647.00
C 333.65 645.48 336.83 644.27 337.00 642.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#EF981C" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 360.00 653.00 
C 360.00 653.00 360.20 653.60 360.00 654.00
C 353.24 662.45 344.71 670.08 339.00 679.00
C 343.77 687.38 351.14 683.73 355.23 677.23 C 359.32 670.73 364.58 668.10 369.00 662.00
C 372.49 668.33 383.44 661.37 378.25 656.75 C 373.06 652.14 371.12 649.90 365.75 645.25 C 360.38 640.59 355.61 647.26 360.00 653.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#F5CA88" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 287.00 669.00 
C 289.55 672.11 293.36 674.91 296.00 678.00
C 306.91 690.77 319.54 702.97 332.00 713.00
C 311.00 692.00 289.70 669.34 271.00 646.00
C 272.21 653.06 282.91 663.15 287.00 669.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#F6D39C" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 561.00 671.00 
C 558.76 664.28 555.09 657.19 553.00 651.00
C 554.63 658.35 557.63 664.82 561.00 671.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#FDF6E6" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 320.00 653.00 
C 319.63 655.83 315.96 654.17 315.00 656.00
C 315.08 659.82 323.02 661.59 322.00 661.00
C 321.83 659.71 320.30 659.25 320.00 658.00
C 321.98 656.62 324.84 654.64 325.00 652.00
C 323.07 651.49 321.76 653.03 320.00 653.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#FDEDD1" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 338.00 677.00 
C 343.37 673.81 347.91 666.79 352.00 662.00
C 347.64 666.36 342.77 673.48 338.00 677.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#FDEED3" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 296.00 678.00 
C 293.36 674.91 289.55 672.11 287.00 669.00
C 289.62 672.74 292.89 675.18 296.00 678.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#F6D49D" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 736.00 698.00 
C 739.84 696.40 746.96 694.63 749.22 690.22 C 751.48 685.81 748.43 676.46 748.00 672.00
C 748.00 676.56 750.08 686.79 748.23 690.23 C 746.38 693.67 738.98 696.34 736.00 698.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#F9DEB1" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 517.00 695.00 
C 527.16 693.74 535.39 700.24 534.00 711.00
C 529.80 709.97 525.82 713.63 522.00 711.00
C 523.10 712.82 525.73 713.67 528.00 714.00
C 530.20 714.32 534.36 713.01 536.00 715.00
C 535.07 711.97 531.35 713.26 529.00 713.00
C 537.01 713.08 535.34 704.31 533.00 699.00
C 538.34 701.39 543.53 703.85 549.00 706.00
C 534.19 698.09 520.25 689.32 507.00 678.00
C 512.28 684.07 518.10 689.62 525.00 693.00
C 523.05 694.13 519.15 694.47 517.00 695.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#F6D499" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 386.00 683.00 
C 383.11 684.69 380.83 687.92 380.00 691.00
C 383.82 690.71 385.13 685.99 386.00 683.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#EF9B2A" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 406.00 720.00 
C 406.00 721.33 406.00 722.67 406.00 724.00
C 410.07 724.04 415.03 729.70 418.00 725.00
C 419.16 720.93 421.55 717.28 422.00 713.00
C 433.67 717.83 439.58 708.52 441.00 698.00 C 442.42 687.48 427.86 684.15 420.00 683.00
C 414.07 694.66 412.36 708.56 406.00 720.00
M 427.00 704.00 
C 424.81 701.56 428.03 697.73 429.00 695.00
C 431.50 697.44 428.96 702.05 427.00 704.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#EF9C2C" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 454.00 728.00 
C 456.16 719.47 455.08 713.35 459.02 705.02 C 462.97 696.70 458.02 690.99 448.00 693.00
C 447.81 699.90 444.82 706.31 443.98 712.98 C 443.13 719.64 440.14 726.28 440.01 732.99 C 439.88 739.70 453.65 736.98 458.00 739.00
C 460.62 734.27 460.95 727.96 454.00 728.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#FBE6C2" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 427.00 704.00 
C 428.96 702.05 431.50 697.44 429.00 695.00
C 428.03 697.73 424.81 701.56 427.00 704.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#EF9B29" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 536.00 715.00 
C 534.36 713.01 530.20 714.32 528.00 714.00
C 526.28 714.17 523.05 715.41 521.00 716.00
C 521.33 712.17 518.17 707.23 521.00 704.00
C 521.56 706.24 522.38 708.48 522.00 711.00
C 525.82 713.63 529.80 709.97 534.00 711.00
C 535.39 700.24 527.16 693.74 517.00 695.00
C 512.19 696.19 506.93 699.11 507.00 705.00 C 507.07 710.89 507.94 716.41 509.01 721.99 C 510.08 727.58 509.64 732.12 513.25 736.75 C 516.86 741.38 523.62 739.87 527.25 738.26 C 530.89 736.65 540.75 739.09 537.99 732.01 C 535.24 724.92 539.39 720.83 536.00 715.00
M 524.00 731.00 
C 522.60 728.96 521.98 725.77 522.00 723.00
C 525.93 722.66 525.83 729.28 524.00 731.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#EF9922" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 484.00 697.00 
C 480.00 697.00 476.00 697.00 472.00 697.00
C 473.50 710.51 462.33 741.73 484.00 742.00 C 505.67 742.26 494.82 711.31 498.00 698.00
C 486.18 694.15 485.78 702.74 486.00 711.00 C 486.21 719.25 484.63 725.49 484.00 733.00
C 480.97 721.72 485.34 709.08 484.00 697.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#FDFBF1" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 376.00 699.00 
C 373.39 699.41 368.60 703.14 371.00 706.00
C 373.81 705.49 375.39 701.65 376.00 699.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#FCF6E3" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 528.00 714.00 
C 525.73 713.67 523.10 712.82 522.00 711.00
C 522.38 708.48 521.56 706.24 521.00 704.00
C 518.17 707.23 521.33 712.17 521.00 716.00
C 523.05 715.41 526.28 714.17 528.00 714.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#FAE2B8" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 398.00 721.00 
C 404.47 724.92 411.31 726.84 418.00 730.00
C 417.85 728.17 415.24 729.67 415.00 728.00
C 417.41 728.63 417.40 726.26 418.00 725.00
C 415.03 729.70 410.07 724.04 406.00 724.00
C 406.00 722.67 406.00 721.33 406.00 720.00
C 404.25 720.40 403.70 722.43 404.00 724.00
C 402.01 722.85 399.99 721.89 398.00 721.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#FCEFD4" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 524.00 731.00 
C 525.83 729.28 525.93 722.66 522.00 723.00
C 521.98 725.77 522.60 728.96 524.00 731.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#F6D39C" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 581.00 745.00 
C 587.33 744.47 591.78 742.64 597.00 740.00
C 593.08 740.94 585.89 743.68 581.00 745.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#F5D299" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 540.00 751.00 
C 553.36 751.00 565.71 747.22 578.00 745.00
C 565.62 744.67 552.02 749.84 540.00 751.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#F1C47C" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 506.00 751.00 
C 501.77 750.59 495.90 750.39 491.00 750.00
C 495.43 750.86 500.85 751.00 506.00 751.00 Z"
          />
        </g>
        <g fill="None" fillOpacity="0.0" stroke="#F5D198" strokeOpacity="1.00" strokeWidth="0.3">
          <path
            d="
M 560.00 777.00 
C 565.98 776.33 571.63 775.33 577.00 774.00
C 571.20 774.83 565.29 775.90 560.00 777.00 Z"
          />
        </g>
        <g fill="#FEFEFE" fillOpacity="1.00" stroke="None">
          <path
            d="
M 0.00 1000.00 
L 1000.00 1000.00
L 1000.00 0.00
L 0.00 0.00
L 0.00 1000.00
M 712.00 242.00 
C 715.07 244.57 718.79 247.79 722.00 251.00
C 748.08 273.28 762.78 293.94 780.30 322.70 C 797.83 351.45 810.47 380.06 817.99 415.01 C 825.51 449.96 822.03 498.96 818.00 535.00
C 816.86 545.23 813.73 554.62 811.00 564.00
C 808.19 580.31 798.95 599.07 792.07 614.07 C 785.20 629.08 774.16 644.57 763.00 655.00
C 761.57 645.13 760.05 635.24 760.00 625.00
C 758.70 611.62 763.58 604.27 770.00 593.00
C 775.81 579.21 784.03 564.11 786.00 549.00
C 786.56 544.73 788.32 540.74 789.00 537.00
C 789.00 536.01 788.95 534.99 789.00 534.00
C 789.31 527.99 791.92 520.61 793.00 515.00
C 794.96 490.33 797.27 461.52 792.67 437.33 C 788.07 413.14 782.78 394.18 775.00 372.00
C 764.38 350.52 751.90 325.61 736.00 307.00
C 723.42 292.28 710.94 279.72 696.75 267.25 C 682.55 254.79 665.22 245.55 650.00 235.00
C 639.50 229.86 627.70 224.20 617.00 220.00
C 594.98 213.95 577.33 208.32 553.98 205.02 C 530.63 201.73 504.59 205.04 481.00 206.00
C 476.41 206.67 472.22 208.53 467.00 209.00
C 448.68 210.67 436.25 218.23 418.77 223.77 C 401.29 229.31 377.12 226.28 358.00 227.00
C 371.09 212.40 388.60 206.82 407.01 198.01 C 425.42 189.20 446.86 183.85 468.00 180.00 C 489.14 176.15 519.62 174.77 542.00 176.00 C 564.38 177.23 588.99 181.78 609.22 187.78 C 629.46 193.78 646.22 201.56 664.22 210.78 C 682.22 219.99 696.04 229.72 712.00 242.00
M 434.00 256.00 
C 425.94 256.64 419.45 259.52 413.25 265.25 C 407.05 270.98 404.39 277.37 403.00 286.00 C 401.61 294.63 401.97 306.31 402.00 316.00 C 402.03 325.69 401.99 336.97 402.00 347.00 C 402.01 357.03 401.99 367.82 402.00 378.00 C 402.01 388.18 401.98 398.78 402.00 409.00 C 402.02 419.22 401.97 429.82 402.00 440.00 C 402.03 450.18 401.93 460.95 402.00 471.00 C 402.07 481.05 401.85 492.27 402.00 502.00 C 402.15 511.73 401.67 524.00 402.00 533.00 C 402.33 542.00 405.91 550.27 408.31 557.69 C 410.70 565.12 417.79 570.74 423.08 573.92 C 428.37 577.10 446.13 579.78 437.00 589.00
C 432.04 594.01 418.44 588.39 411.00 590.00 C 403.56 591.61 392.27 589.25 384.00 590.00 C 375.73 590.75 365.62 589.61 357.00 590.00 C 348.38 590.39 338.72 589.71 330.00 590.00
C 332.10 593.12 334.18 596.33 335.00 600.00
C 339.01 611.13 336.26 619.19 325.92 622.92 C 315.58 626.65 307.72 636.26 299.75 628.25 C 291.79 620.23 288.63 610.15 298.25 606.25 C 307.87 602.34 314.94 597.58 324.00 593.00
C 325.07 592.09 325.92 590.80 327.00 590.00
C 316.50 589.34 304.68 591.33 295.00 589.00
C 293.28 586.54 296.29 580.76 295.00 578.00
C 326.28 573.51 329.04 543.81 329.00 515.00 C 328.96 486.19 328.77 446.78 329.00 417.00 C 329.23 387.22 328.35 348.93 329.00 320.00 C 329.65 291.07 330.53 257.27 296.00 255.00
C 293.72 253.67 292.77 247.48 294.00 245.00
C 296.38 240.19 305.68 243.80 311.00 243.00 C 316.32 242.20 324.98 243.35 331.00 243.00 C 337.02 242.65 344.72 243.12 351.00 243.00 C 357.28 242.88 363.59 242.95 370.00 243.00 C 376.41 243.05 383.55 242.78 390.00 243.00 C 396.45 243.22 403.64 242.46 410.00 243.00 C 416.36 243.54 422.87 241.71 429.00 243.00 C 435.13 244.29 443.42 238.58 444.99 247.01 C 446.57 255.44 441.02 255.44 434.00 256.00
M 478.00 504.00 
C 475.57 502.54 476.64 505.12 474.00 505.00
C 476.63 497.65 466.54 492.85 465.00 486.00
C 459.38 476.33 449.34 466.42 444.08 456.92 C 438.83 447.42 423.01 437.19 430.00 427.00
C 442.59 408.65 458.92 393.14 473.00 376.00
C 476.97 370.32 481.56 364.75 486.25 359.25 C 490.93 353.75 494.31 347.73 499.30 342.30 C 504.30 336.87 507.23 330.99 512.25 325.25 C 517.28 319.51 518.66 313.42 521.92 306.92 C 525.19 300.43 529.88 291.57 529.93 283.93 C 529.97 276.28 529.19 266.74 521.10 262.90 C 513.01 259.06 509.83 255.80 498.93 255.07 C 488.03 254.34 489.81 242.11 502.00 244.00 C 514.19 245.89 521.91 243.11 533.00 244.00 C 544.09 244.89 552.48 243.60 563.00 244.00 C 573.52 244.40 582.71 243.81 593.00 244.00 C 603.29 244.19 612.74 243.91 623.00 244.00 C 633.26 244.09 643.72 243.93 654.00 244.00
C 658.68 257.91 643.27 254.89 634.99 255.99 C 626.71 257.09 617.83 259.80 610.77 263.77 C 603.72 267.74 597.16 270.30 590.97 274.97 C 584.78 279.65 578.99 284.22 573.25 289.25 C 567.51 294.28 563.11 299.50 557.25 304.25 C 551.39 309.00 546.87 315.47 541.75 320.75 C 536.63 326.03 531.32 331.13 526.75 336.75 C 522.19 342.37 516.14 348.13 511.75 353.75 C 507.37 359.38 501.26 365.12 498.08 371.08 C 494.91 377.04 484.15 382.21 484.08 389.08 C 484.00 395.94 494.43 401.52 497.25 407.75 C 500.08 413.97 507.07 419.09 510.75 425.25 C 514.44 431.41 520.33 437.53 524.30 443.70 C 528.28 449.86 534.17 454.75 537.75 461.25 C 541.34 467.74 547.68 472.97 551.75 479.25 C 555.82 485.53 560.07 491.18 564.75 497.25 C 569.43 503.31 573.90 509.65 578.90 515.10 C 583.90 520.56 586.44 527.58 591.75 533.25 C 597.06 538.91 600.30 545.31 605.75 551.25 C 611.20 557.18 615.89 560.67 622.23 565.77 C 628.57 570.87 638.08 571.12 645.02 574.98 C 651.96 578.83 668.01 572.98 669.99 582.01 C 671.97 591.03 654.53 589.38 646.00 589.00 C 637.47 588.62 623.25 589.22 614.00 589.00 C 604.75 588.78 592.17 589.19 583.00 589.00 C 573.83 588.81 562.89 587.69 554.93 585.07 C 546.96 582.45 540.97 578.96 534.77 574.23 C 528.57 569.51 523.21 564.59 518.25 558.75 C 513.28 552.92 508.99 547.73 504.25 541.75 C 499.50 535.77 496.28 528.52 491.25 522.75 C 486.21 516.98 482.78 509.98 478.00 504.00
M 258.00 553.00 
C 259.14 555.95 260.97 559.46 262.00 563.00
C 266.45 578.28 273.43 593.47 280.31 607.69 C 287.19 621.92 298.32 632.36 306.00 646.00
C 307.89 648.46 310.58 650.98 313.00 653.00
C 314.64 649.18 305.71 643.77 314.00 642.00
C 323.93 636.52 333.86 629.92 344.00 625.00
C 349.43 622.37 360.04 631.79 357.22 638.22 C 354.40 644.65 345.08 648.82 341.25 654.25 C 337.42 659.67 330.88 669.18 325.00 666.00
C 326.96 670.13 335.25 679.77 338.00 677.00
C 342.77 673.48 347.64 666.36 352.00 662.00
C 354.44 659.14 356.93 656.14 360.00 654.00
C 360.20 653.60 360.00 653.00 360.00 653.00
C 353.21 648.26 359.46 640.04 365.25 643.76 C 371.03 647.47 373.34 651.48 378.75 656.25 C 384.16 661.01 373.63 669.89 369.00 663.00
C 361.94 671.69 353.00 680.06 346.00 688.00
C 352.02 688.00 354.31 693.99 359.00 697.00
C 363.15 690.54 369.00 684.17 375.00 679.00
C 380.48 671.32 384.46 661.78 394.23 666.77 C 404.00 671.76 400.05 680.55 395.08 689.08 C 390.10 697.60 388.03 705.99 382.00 713.00
C 387.67 715.01 392.22 719.42 398.00 721.00
C 399.99 721.89 402.01 722.85 404.00 724.00
C 403.70 722.43 404.25 720.40 406.00 720.00
C 412.36 708.56 414.07 694.66 420.00 683.00
C 427.86 684.15 442.42 687.48 441.00 698.00 C 439.58 708.52 433.67 717.83 422.00 713.00
C 421.55 717.28 419.16 720.93 418.00 725.00
C 417.40 726.26 417.41 728.63 415.00 728.00
C 415.24 729.67 417.85 728.17 418.00 730.00
C 426.24 737.49 440.60 738.73 451.69 742.31 C 462.79 745.89 479.03 749.05 491.00 750.00
C 495.90 750.39 501.77 750.59 506.00 751.00
C 517.33 751.00 528.67 751.00 540.00 751.00
C 552.02 749.84 565.62 744.67 578.00 745.00
C 578.98 745.03 580.03 745.08 581.00 745.00
C 585.89 743.68 593.08 740.94 597.00 740.00
C 622.11 733.98 650.19 737.25 676.00 733.00
C 671.66 743.37 659.03 746.24 648.75 751.75 C 638.48 757.27 625.55 760.00 614.33 764.33 C 603.11 768.66 589.25 772.14 577.00 774.00
C 571.63 775.33 565.98 776.33 560.00 777.00
C 546.47 778.51 530.86 779.67 517.00 779.00 C 503.14 778.33 487.01 778.22 474.00 776.00 C 460.99 773.78 449.06 770.98 437.00 768.00 C 424.94 765.03 414.95 758.93 403.78 755.22 C 392.60 751.51 383.68 745.52 373.31 740.70 C 362.93 735.87 355.29 726.52 345.00 725.00
C 344.06 719.05 336.20 716.83 332.00 713.00
C 319.54 702.97 306.91 690.77 296.00 678.00
C 292.89 675.18 289.62 672.74 287.00 669.00
C 282.91 663.15 272.21 653.06 271.00 646.00
C 270.92 645.51 271.15 644.45 271.00 644.00
C 266.58 638.28 260.85 629.46 256.00 627.00
C 258.28 620.81 251.25 616.11 250.00 610.00
C 245.99 600.36 240.24 590.28 238.00 580.00
C 236.01 574.39 233.43 568.46 232.00 562.00
C 231.24 558.56 230.19 555.34 229.00 552.00
C 227.35 547.35 226.97 542.19 226.00 537.00
C 224.02 526.37 222.99 517.30 222.00 506.00
C 220.98 500.73 220.00 495.27 220.00 489.00
C 220.00 481.67 220.00 474.33 220.00 467.00
C 220.00 456.60 221.86 447.39 223.00 438.00
C 223.27 424.27 226.63 406.93 230.33 394.33 C 234.03 381.73 240.27 369.46 244.78 357.78 C 249.28 346.10 256.09 334.23 261.92 323.92 C 267.75 313.60 275.02 301.20 282.75 293.75 C 290.48 286.31 297.71 265.23 307.90 276.10 C 318.09 286.97 310.34 303.97 302.25 313.25 C 294.15 322.53 289.22 333.88 282.68 344.68 C 276.14 355.48 270.37 366.37 266.03 379.03 C 261.68 391.68 257.23 403.56 253.08 417.08 C 248.92 430.59 250.57 448.13 248.00 463.00 C 245.43 477.87 248.86 495.20 249.93 510.07 C 250.99 524.94 254.41 538.94 258.00 553.00
M 641.00 367.00 
C 660.05 367.00 678.55 368.66 696.08 372.92 C 713.61 377.18 723.84 380.79 739.75 390.25 C 755.65 399.72 746.00 422.22 746.00 439.00
C 746.00 445.13 744.64 450.73 744.00 456.00
C 743.73 463.13 744.06 478.89 735.00 476.00 C 725.94 473.11 726.71 465.44 724.00 458.00
C 717.51 445.85 710.96 432.60 703.00 421.00
C 697.12 412.42 690.56 404.74 682.25 397.75 C 673.93 390.76 663.78 386.81 653.32 382.68 C 642.86 378.54 624.75 378.34 613.00 379.00 C 601.25 379.66 589.14 382.95 579.92 389.92 C 570.70 396.89 565.73 404.60 560.70 414.70 C 555.66 424.79 553.02 436.88 550.22 448.22 C 547.42 459.56 535.43 442.32 531.25 434.75 C 527.06 427.19 515.31 418.80 512.25 409.75 C 509.18 400.70 525.56 394.63 533.23 389.23 C 540.90 383.83 553.82 378.71 564.00 376.00 C 574.18 373.29 588.31 368.00 600.00 368.00
C 613.14 366.73 627.68 365.71 641.00 367.00
M 553.00 651.00 
C 555.09 657.19 558.76 664.28 561.00 671.00
C 563.83 679.49 568.35 684.53 574.75 691.25 C 581.15 697.97 587.37 701.57 596.07 704.93 C 604.78 708.28 617.14 709.45 627.00 709.00 C 636.86 708.55 647.58 706.41 656.22 703.22 C 664.86 700.03 671.82 695.82 679.08 691.08 C 686.34 686.35 692.52 681.67 698.25 675.25 C 703.98 668.82 708.97 662.12 713.25 655.25 C 717.54 648.39 722.48 638.92 724.92 631.92 C 727.37 624.93 729.66 607.63 739.00 611.00 C 748.34 614.37 743.56 630.78 745.00 640.00 C 746.44 649.22 748.00 662.32 748.00 672.00
C 748.43 676.46 751.48 685.81 749.22 690.22 C 746.96 694.63 739.84 696.40 736.00 698.00
C 683.06 727.50 604.63 727.83 549.00 706.00
C 543.53 703.85 538.34 701.39 533.00 699.00
C 535.34 704.31 537.01 713.08 529.00 713.00
C 531.35 713.26 535.07 711.97 536.00 715.00
C 539.39 720.83 535.24 724.92 537.99 732.01 C 540.75 739.09 530.89 736.65 527.25 738.26 C 523.62 739.87 516.86 741.38 513.25 736.75 C 509.64 732.12 510.08 727.58 509.01 721.99 C 507.94 716.41 507.07 710.89 507.00 705.00 C 506.93 699.11 512.19 696.19 517.00 695.00
C 519.15 694.47 523.05 694.13 525.00 693.00
C 518.10 689.62 512.28 684.07 507.00 678.00
C 493.94 666.84 481.82 651.93 475.00 637.00
C 472.09 632.20 469.18 627.45 467.00 622.00
C 466.83 621.57 467.00 621.00 467.00 621.00
C 465.07 617.31 462.84 613.33 462.00 609.00
C 460.19 599.64 457.18 590.95 455.67 581.33 C 454.16 571.71 451.32 560.06 452.00 550.00 C 452.68 539.94 451.54 525.80 453.00 517.00 C 454.46 508.20 456.85 491.65 462.77 500.23 C 468.69 508.81 471.42 512.82 476.75 520.25 C 482.09 527.67 485.59 534.08 491.25 540.75 C 496.91 547.42 499.69 553.85 506.25 559.75 C 512.80 565.65 516.48 572.53 523.08 577.92 C 529.68 583.30 536.24 588.90 544.00 592.00
C 544.70 612.26 548.75 631.63 553.00 651.00
M 454.00 728.00 
C 460.95 727.96 460.62 734.27 458.00 739.00
C 453.65 736.98 439.88 739.70 440.01 732.99 C 440.14 726.28 443.13 719.64 443.98 712.98 C 444.82 706.31 447.81 699.90 448.00 693.00
C 458.02 690.99 462.97 696.70 459.02 705.02 C 455.08 713.35 456.16 719.47 454.00 728.00
M 484.00 697.00 
C 485.34 709.08 480.97 721.72 484.00 733.00
C 484.63 725.49 486.21 719.25 486.00 711.00 C 485.78 702.74 486.18 694.15 498.00 698.00
C 494.82 711.31 505.67 742.26 484.00 742.00 C 462.33 741.73 473.50 710.51 472.00 697.00
C 476.00 697.00 480.00 697.00 484.00 697.00 Z"
          />
        </g>
        <g fill="#F09920" fillOpacity="1.00" stroke="None">
          <path
            d="
M 467.00 209.00 
C 471.71 208.02 475.59 206.22 481.00 206.00
C 504.59 205.04 530.63 201.73 553.98 205.02 C 577.33 208.32 594.98 213.95 617.00 220.00
C 628.02 223.03 640.66 228.53 650.00 235.00
C 665.22 245.55 682.55 254.79 696.75 267.25 C 710.94 279.72 723.42 292.28 736.00 307.00
C 752.82 323.82 767.29 350.03 775.00 372.00
C 782.78 394.18 788.07 413.14 792.67 437.33 C 797.27 461.52 794.96 490.33 793.00 515.00
C 792.43 522.21 790.42 527.74 789.00 534.00
C 788.95 534.99 789.00 536.01 789.00 537.00
C 789.02 541.49 786.89 545.18 786.00 549.00
C 784.03 564.11 775.81 579.21 770.00 593.00
C 765.16 604.47 760.00 611.67 760.00 625.00
C 760.05 635.24 761.57 645.13 763.00 655.00
C 774.16 644.57 785.20 629.08 792.07 614.07 C 798.95 599.07 808.19 580.31 811.00 564.00
C 812.70 554.13 815.82 544.38 818.00 535.00
C 822.03 498.96 825.51 449.96 817.99 415.01 C 810.47 380.06 797.83 351.45 780.30 322.70 C 762.78 293.94 748.08 273.28 722.00 251.00
C 718.48 247.99 715.22 245.22 712.00 242.00
C 696.04 229.72 682.22 219.99 664.22 210.78 C 646.22 201.56 629.46 193.78 609.22 187.78 C 588.99 181.78 564.38 177.23 542.00 176.00 C 519.62 174.77 489.14 176.15 468.00 180.00 C 446.86 183.85 425.42 189.20 407.01 198.01 C 388.60 206.82 371.09 212.40 358.00 227.00
C 377.12 226.28 401.29 229.31 418.77 223.77 C 436.25 218.23 448.68 210.67 467.00 209.00 Z"
          />
        </g>
        <g fill="#F7D49D" fillOpacity="1.00" stroke="None">
          <path
            d="
M 467.00 209.00 
C 472.22 208.53 476.41 206.67 481.00 206.00
C 475.59 206.22 471.71 208.02 467.00 209.00 Z"
          />
        </g>
        <g fill="#F6CE93" fillOpacity="1.00" stroke="None">
          <path
            d="
M 650.00 235.00 
C 640.66 228.53 628.02 223.03 617.00 220.00
C 627.70 224.20 639.50 229.86 650.00 235.00 Z"
          />
        </g>
        <g fill="#FEF0D4" fillOpacity="1.00" stroke="None">
          <path
            d="
M 722.00 251.00 
C 718.79 247.79 715.07 244.57 712.00 242.00
C 715.22 245.22 718.48 247.99 722.00 251.00 Z"
          />
        </g>
        <g fill="#FAF2DD" fillOpacity="1.00" stroke="None">
          <path
            d="
M 294.00 245.00 
C 296.97 240.80 307.68 245.19 313.00 244.00 C 318.32 242.81 327.88 244.60 334.00 244.00 C 340.12 243.40 347.47 244.34 354.00 244.00 C 360.53 243.66 368.32 244.33 375.00 244.00 C 381.68 243.67 388.26 244.56 395.00 244.00 C 401.74 243.44 409.26 245.10 416.00 244.00 C 422.74 242.90 429.35 246.52 436.00 244.00 C 442.65 241.48 448.57 251.75 442.00 255.00
C 440.58 255.70 435.29 255.75 434.00 256.00
C 441.02 255.44 446.57 255.44 444.99 247.01 C 443.42 238.58 435.13 244.29 429.00 243.00 C 422.87 241.71 416.36 243.54 410.00 243.00 C 403.64 242.46 396.45 243.22 390.00 243.00 C 383.55 242.78 376.41 243.05 370.00 243.00 C 363.59 242.95 357.28 242.88 351.00 243.00 C 344.72 243.12 337.02 242.65 331.00 243.00 C 324.98 243.35 316.32 242.20 311.00 243.00 C 305.68 243.80 296.38 240.19 294.00 245.00 Z"
          />
        </g>
        <g fill="#F1B763" fillOpacity="1.00" stroke="None">
          <path
            d="
M 294.00 245.00 
C 292.77 247.48 293.72 253.67 296.00 255.00
C 293.44 252.90 295.88 247.69 295.00 245.00
C 344.33 245.00 393.67 245.00 443.00 245.00
C 442.68 248.34 443.84 252.07 442.00 255.00
C 448.57 251.75 442.65 241.48 436.00 244.00 C 429.35 246.52 422.74 242.90 416.00 244.00 C 409.26 245.10 401.74 243.44 395.00 244.00 C 388.26 244.56 381.68 243.67 375.00 244.00 C 368.32 244.33 360.53 243.66 354.00 244.00 C 347.47 244.34 340.12 243.40 334.00 244.00 C 327.88 244.60 318.32 242.81 313.00 244.00 C 307.68 245.19 296.97 240.80 294.00 245.00 Z"
          />
        </g>
        <g fill="#EF981D" fillOpacity="1.00" stroke="None">
          <path
            d="
M 473.00 376.00 
C 460.38 394.02 444.25 410.49 430.00 427.00
C 423.01 437.19 438.83 447.42 444.08 456.92 C 449.34 466.42 459.38 476.33 465.00 486.00
C 469.48 491.74 473.93 497.69 478.00 504.00
C 482.78 509.98 486.21 516.98 491.25 522.75 C 496.28 528.52 499.50 535.77 504.25 541.75 C 508.99 547.73 513.28 552.92 518.25 558.75 C 523.21 564.59 528.57 569.51 534.77 574.23 C 540.97 578.96 546.96 582.45 554.93 585.07 C 562.89 587.69 573.83 588.81 583.00 589.00 C 592.17 589.19 604.75 588.78 614.00 589.00 C 623.25 589.22 637.47 588.62 646.00 589.00 C 654.53 589.38 671.97 591.03 669.99 582.01 C 668.01 572.98 651.96 578.83 645.02 574.98 C 638.08 571.12 628.57 570.87 622.23 565.77 C 615.89 560.67 611.20 557.18 605.75 551.25 C 600.30 545.31 597.06 538.91 591.75 533.25 C 586.44 527.58 583.90 520.56 578.90 515.10 C 573.90 509.65 569.43 503.31 564.75 497.25 C 560.07 491.18 555.82 485.53 551.75 479.25 C 547.68 472.97 541.34 467.74 537.75 461.25 C 534.17 454.75 528.28 449.86 524.30 443.70 C 520.33 437.53 514.44 431.41 510.75 425.25 C 507.07 419.09 500.08 413.97 497.25 407.75 C 494.43 401.52 484.00 395.94 484.08 389.08 C 484.15 382.21 494.91 377.04 498.08 371.08 C 501.26 365.12 507.37 359.38 511.75 353.75 C 516.14 348.13 522.19 342.37 526.75 336.75 C 531.32 331.13 536.63 326.03 541.75 320.75 C 546.87 315.47 551.39 309.00 557.25 304.25 C 563.11 299.50 567.51 294.28 573.25 289.25 C 578.99 284.22 584.78 279.65 590.97 274.97 C 597.16 270.30 603.72 267.74 610.77 263.77 C 617.83 259.80 626.71 257.09 634.99 255.99 C 643.27 254.89 658.68 257.91 654.00 244.00
C 643.72 243.93 633.26 244.09 623.00 244.00 C 612.74 243.91 603.29 244.19 593.00 244.00 C 582.71 243.81 573.52 244.40 563.00 244.00 C 552.48 243.60 544.09 244.89 533.00 244.00 C 521.91 243.11 514.19 245.89 502.00 244.00 C 489.81 242.11 488.03 254.34 498.93 255.07 C 509.83 255.80 513.01 259.06 521.10 262.90 C 529.19 266.74 529.97 276.28 529.93 283.93 C 529.88 291.57 525.19 300.43 521.92 306.92 C 518.66 313.42 517.28 319.51 512.25 325.25 C 507.23 330.99 504.30 336.87 499.30 342.30 C 494.31 347.73 490.93 353.75 486.25 359.25 C 481.56 364.75 476.97 370.32 473.00 376.00 Z"
          />
        </g>
        <g fill="#EF9719" fillOpacity="1.00" stroke="None">
          <path
            d="
M 296.00 255.00 
C 330.53 257.27 329.65 291.07 329.00 320.00 C 328.35 348.93 329.23 387.22 329.00 417.00 C 328.77 446.78 328.96 486.19 329.00 515.00 C 329.04 543.81 326.28 573.51 295.00 578.00
C 296.29 580.76 293.28 586.54 295.00 589.00
C 301.67 588.97 308.33 589.03 315.00 589.00 C 321.67 588.97 328.33 589.07 335.00 589.00 C 341.67 588.93 348.32 589.14 355.00 589.00 C 361.68 588.86 369.41 589.30 376.00 589.00 C 382.59 588.70 389.71 589.69 396.00 589.00 C 402.29 588.31 410.26 590.54 416.00 589.00 C 421.74 587.46 432.42 592.24 437.00 589.00
C 446.13 579.78 428.37 577.10 423.08 573.92 C 417.79 570.74 410.70 565.12 408.31 557.69 C 405.91 550.27 402.33 542.00 402.00 533.00 C 401.67 524.00 402.15 511.73 402.00 502.00 C 401.85 492.27 402.07 481.05 402.00 471.00 C 401.93 460.95 402.03 450.18 402.00 440.00 C 401.97 429.82 402.02 419.22 402.00 409.00 C 401.98 398.78 402.01 388.18 402.00 378.00 C 401.99 367.82 402.01 357.03 402.00 347.00 C 401.99 336.97 402.03 325.69 402.00 316.00 C 401.97 306.31 401.61 294.63 403.00 286.00 C 404.39 277.37 407.05 270.98 413.25 265.25 C 419.45 259.52 425.94 256.64 434.00 256.00
C 435.29 255.75 440.58 255.70 442.00 255.00
C 443.84 252.07 442.68 248.34 443.00 245.00
C 393.67 245.00 344.33 245.00 295.00 245.00
C 295.88 247.69 293.44 252.90 296.00 255.00 Z"
          />
        </g>
        <g fill="#EF981F" fillOpacity="1.00" stroke="None">
          <path
            d="
M 223.00 438.00 
C 222.80 447.83 220.91 457.65 220.00 467.00
C 220.00 474.33 220.00 481.67 220.00 489.00
C 220.48 493.97 221.53 500.66 222.00 506.00
C 222.99 517.30 224.02 526.37 226.00 537.00
C 227.39 541.64 227.83 546.96 229.00 552.00
C 230.19 555.34 231.24 558.56 232.00 562.00
C 234.04 567.75 236.63 573.73 238.00 580.00
C 240.24 590.28 245.99 600.36 250.00 610.00
C 253.15 615.20 257.84 620.93 259.97 627.03 C 262.10 633.12 268.94 638.03 271.00 644.00
C 271.15 644.45 270.92 645.51 271.00 646.00
C 289.70 669.34 311.00 692.00 332.00 713.00
C 336.20 716.83 344.06 719.05 345.00 725.00
C 355.29 726.52 362.93 735.87 373.31 740.70 C 383.68 745.52 392.60 751.51 403.78 755.22 C 414.95 758.93 424.94 765.03 437.00 768.00 C 449.06 770.98 460.99 773.78 474.00 776.00 C 487.01 778.22 503.14 778.33 517.00 779.00 C 530.86 779.67 546.47 778.51 560.00 777.00
C 565.29 775.90 571.20 774.83 577.00 774.00
C 589.25 772.14 603.11 768.66 614.33 764.33 C 625.55 760.00 638.48 757.27 648.75 751.75 C 659.03 746.24 671.66 743.37 676.00 733.00
C 650.19 737.25 622.11 733.98 597.00 740.00
C 591.78 742.64 587.33 744.47 581.00 745.00
C 580.03 745.08 578.98 745.03 578.00 745.00
C 565.71 747.22 553.36 751.00 540.00 751.00
C 528.67 751.00 517.33 751.00 506.00 751.00
C 500.85 751.00 495.43 750.86 491.00 750.00
C 479.03 749.05 462.79 745.89 451.69 742.31 C 440.60 738.73 426.24 737.49 418.00 730.00
C 411.31 726.84 404.47 724.92 398.00 721.00
C 392.22 719.42 387.67 715.01 382.00 713.00
C 388.03 705.99 390.10 697.60 395.08 689.08 C 400.05 680.55 404.00 671.76 394.23 666.77 C 384.46 661.78 380.48 671.32 375.00 679.00
C 370.50 685.29 363.83 690.55 360.00 697.00
C 363.64 698.56 366.38 701.46 370.00 703.00
C 372.08 700.65 373.14 696.96 377.00 698.00
C 377.53 700.46 376.42 703.13 374.00 704.00
C 373.84 707.84 379.01 707.76 380.00 711.00
C 351.31 695.76 325.29 671.72 306.00 646.00
C 298.32 632.36 287.19 621.92 280.31 607.69 C 273.43 593.47 266.45 578.28 262.00 563.00
C 260.61 559.63 258.98 556.84 258.00 553.00
C 254.41 538.94 250.99 524.94 249.93 510.07 C 248.86 495.20 245.43 477.87 248.00 463.00 C 250.57 448.13 248.92 430.59 253.08 417.08 C 257.23 403.56 261.68 391.68 266.03 379.03 C 270.37 366.37 276.14 355.48 282.68 344.68 C 289.22 333.88 294.15 322.53 302.25 313.25 C 310.34 303.97 318.09 286.97 307.90 276.10 C 297.71 265.23 290.48 286.31 282.75 293.75 C 275.02 301.20 267.75 313.60 261.92 323.92 C 256.09 334.23 249.28 346.10 244.78 357.78 C 240.27 369.46 234.03 381.73 230.33 394.33 C 226.63 406.93 223.27 424.27 223.00 438.00
M 386.00 683.00 
C 385.13 685.99 383.82 690.71 380.00 691.00
C 380.83 687.92 383.11 684.69 386.00 683.00 Z"
          />
        </g>
        <g fill="#F7D197" fillOpacity="1.00" stroke="None">
          <path
            d="
M 775.00 372.00 
C 767.29 350.03 752.82 323.82 736.00 307.00
C 751.90 325.61 764.38 350.52 775.00 372.00 Z"
          />
        </g>
        <g fill="#F2C683" fillOpacity="1.00" stroke="None">
          <path
            d="
M 600.00 368.00 
C 613.62 368.00 627.13 367.00 641.00 367.00
C 627.68 365.71 613.14 366.73 600.00 368.00 Z"
          />
        </g>
        <g fill="#F09922" fillOpacity="1.00" stroke="None">
          <path
            d="
M 600.00 368.00 
C 588.31 368.00 574.18 373.29 564.00 376.00 C 553.82 378.71 540.90 383.83 533.23 389.23 C 525.56 394.63 509.18 400.70 512.25 409.75 C 515.31 418.80 527.06 427.19 531.25 434.75 C 535.43 442.32 547.42 459.56 550.22 448.22 C 553.02 436.88 555.66 424.79 560.70 414.70 C 565.73 404.60 570.70 396.89 579.92 389.92 C 589.14 382.95 601.25 379.66 613.00 379.00 C 624.75 378.34 642.86 378.54 653.32 382.68 C 663.78 386.81 673.93 390.76 682.25 397.75 C 690.56 404.74 697.12 412.42 703.00 421.00
C 711.97 431.39 719.31 445.14 724.00 458.00
C 726.71 465.44 725.94 473.11 735.00 476.00 C 744.06 478.89 743.73 463.13 744.00 456.00
C 744.22 450.36 745.51 444.07 746.00 439.00
C 746.00 422.22 755.65 399.72 739.75 390.25 C 723.84 380.79 713.61 377.18 696.08 372.92 C 678.55 368.66 660.05 367.00 641.00 367.00
C 627.13 367.00 613.62 368.00 600.00 368.00 Z"
          />
        </g>
        <g fill="#F5C887" fillOpacity="1.00" stroke="None">
          <path
            d="
M 430.00 427.00 
C 444.25 410.49 460.38 394.02 473.00 376.00
C 458.92 393.14 442.59 408.65 430.00 427.00 Z"
          />
        </g>
        <g fill="#F7D39B" fillOpacity="1.00" stroke="None">
          <path
            d="
M 724.00 458.00 
C 719.31 445.14 711.97 431.39 703.00 421.00
C 710.96 432.60 717.51 445.85 724.00 458.00 Z"
          />
        </g>
        <g fill="#F4C784" fillOpacity="1.00" stroke="None">
          <path
            d="
M 220.00 467.00 
C 220.91 457.65 222.80 447.83 223.00 438.00
C 221.86 447.39 220.00 456.60 220.00 467.00 Z"
          />
        </g>
        <g fill="#F7CA89" fillOpacity="1.00" stroke="None">
          <path
            d="
M 744.00 456.00 
C 744.64 450.73 746.00 445.13 746.00 439.00
C 745.51 444.07 744.22 450.36 744.00 456.00 Z"
          />
        </g>
        <g fill="#FDF1D9" fillOpacity="1.00" stroke="None">
          <path
            d="
M 478.00 504.00 
C 473.93 497.69 469.48 491.74 465.00 486.00
C 466.54 492.85 476.63 497.65 474.00 505.00
C 476.64 505.12 475.57 502.54 478.00 504.00 Z"
          />
        </g>
        <g fill="#F6CE93" fillOpacity="1.00" stroke="None">
          <path
            d="
M 222.00 506.00 
C 221.53 500.66 220.48 493.97 220.00 489.00
C 220.00 495.27 220.98 500.73 222.00 506.00 Z"
          />
        </g>
        <g fill="#EF981C" fillOpacity="1.00" stroke="None">
          <path
            d="
M 462.00 609.00 
C 463.17 612.85 466.91 616.43 467.00 621.00
C 467.00 621.00 466.83 621.57 467.00 622.00
C 470.76 625.84 472.73 632.04 475.00 637.00
C 481.82 651.93 493.94 666.84 507.00 678.00
C 520.25 689.32 534.19 698.09 549.00 706.00
C 604.63 727.83 683.06 727.50 736.00 698.00
C 738.98 696.34 746.38 693.67 748.23 690.23 C 750.08 686.79 748.00 676.56 748.00 672.00
C 748.00 662.32 746.44 649.22 745.00 640.00 C 743.56 630.78 748.34 614.37 739.00 611.00 C 729.66 607.63 727.37 624.93 724.92 631.92 C 722.48 638.92 717.54 648.39 713.25 655.25 C 708.97 662.12 703.98 668.82 698.25 675.25 C 692.52 681.67 686.34 686.35 679.08 691.08 C 671.82 695.82 664.86 700.03 656.22 703.22 C 647.58 706.41 636.86 708.55 627.00 709.00 C 617.14 709.45 604.78 708.28 596.07 704.93 C 587.37 701.57 581.15 697.97 574.75 691.25 C 568.35 684.53 563.83 679.49 561.00 671.00
C 557.63 664.82 554.63 658.35 553.00 651.00
C 548.75 631.63 544.70 612.26 544.00 592.00
C 536.24 588.90 529.68 583.30 523.08 577.92 C 516.48 572.53 512.80 565.65 506.25 559.75 C 499.69 553.85 496.91 547.42 491.25 540.75 C 485.59 534.08 482.09 527.67 476.75 520.25 C 471.42 512.82 468.69 508.81 462.77 500.23 C 456.85 491.65 454.46 508.20 453.00 517.00 C 451.54 525.80 452.68 539.94 452.00 550.00 C 451.32 560.06 454.16 571.71 455.67 581.33 C 457.18 590.95 460.19 599.64 462.00 609.00 Z"
          />
        </g>
        <g fill="#F8D299" fillOpacity="1.00" stroke="None">
          <path
            d="
M 789.00 534.00 
C 790.42 527.74 792.43 522.21 793.00 515.00
C 791.92 520.61 789.31 527.99 789.00 534.00 Z"
          />
        </g>
        <g fill="#F6D096" fillOpacity="1.00" stroke="None">
          <path
            d="
M 811.00 564.00 
C 813.73 554.62 816.86 545.23 818.00 535.00
C 815.82 544.38 812.70 554.13 811.00 564.00 Z"
          />
        </g>
        <g fill="#F8D196" fillOpacity="1.00" stroke="None">
          <path
            d="
M 229.00 552.00 
C 227.83 546.96 227.39 541.64 226.00 537.00
C 226.97 542.19 227.35 547.35 229.00 552.00 Z"
          />
        </g>
        <g fill="#F7D299" fillOpacity="1.00" stroke="None">
          <path
            d="
M 786.00 549.00 
C 786.89 545.18 789.02 541.49 789.00 537.00
C 788.32 540.74 786.56 544.73 786.00 549.00 Z"
          />
        </g>
        <g fill="#F9D399" fillOpacity="1.00" stroke="None">
          <path
            d="
M 262.00 563.00 
C 260.97 559.46 259.14 555.95 258.00 553.00
C 258.98 556.84 260.61 559.63 262.00 563.00 Z"
          />
        </g>
        <g fill="#F8D29A" fillOpacity="1.00" stroke="None">
          <path
            d="
M 238.00 580.00 
C 236.63 573.73 234.04 567.75 232.00 562.00
C 233.43 568.46 236.01 574.39 238.00 580.00 Z"
          />
        </g>
        <g fill="#FDFAE7" fillOpacity="1.00" stroke="None">
          <path
            d="
M 324.00 593.00 
C 330.60 589.66 332.24 594.42 335.00 600.00
C 334.18 596.33 332.10 593.12 330.00 590.00
C 338.72 589.71 348.38 590.39 357.00 590.00 C 365.62 589.61 375.73 590.75 384.00 590.00 C 392.27 589.25 403.56 591.61 411.00 590.00 C 418.44 588.39 432.04 594.01 437.00 589.00
C 432.42 592.24 421.74 587.46 416.00 589.00 C 410.26 590.54 402.29 588.31 396.00 589.00 C 389.71 589.69 382.59 588.70 376.00 589.00 C 369.41 589.30 361.68 588.86 355.00 589.00 C 348.32 589.14 341.67 588.93 335.00 589.00 C 328.33 589.07 321.67 588.97 315.00 589.00 C 308.33 589.03 301.67 588.97 295.00 589.00
C 304.68 591.33 316.50 589.34 327.00 590.00
C 325.92 590.80 325.07 592.09 324.00 593.00 Z"
          />
        </g>
        <g fill="#EF9B27" fillOpacity="1.00" stroke="None">
          <path
            d="
M 324.00 593.00 
C 314.94 597.58 307.87 602.34 298.25 606.25 C 288.63 610.15 291.79 620.23 299.75 628.25 C 307.72 636.26 315.58 626.65 325.92 622.92 C 336.26 619.19 339.01 611.13 335.00 600.00
C 332.24 594.42 330.60 589.66 324.00 593.00
M 328.00 606.00 
C 323.10 612.63 312.55 615.17 305.00 619.00
C 310.14 612.72 320.25 609.09 328.00 606.00 Z"
          />
        </g>
        <g fill="#F6D096" fillOpacity="1.00" stroke="None">
          <path
            d="
M 760.00 625.00 
C 760.00 611.67 765.16 604.47 770.00 593.00
C 763.58 604.27 758.70 611.62 760.00 625.00 Z"
          />
        </g>
        <g fill="#FAE8C7" fillOpacity="1.00" stroke="None">
          <path
            d="
M 328.00 606.00 
C 320.25 609.09 310.14 612.72 305.00 619.00
C 312.55 615.17 323.10 612.63 328.00 606.00 Z"
          />
        </g>
        <g fill="#F8D39C" fillOpacity="1.00" stroke="None">
          <path
            d="
M 467.00 621.00 
C 466.91 616.43 463.17 612.85 462.00 609.00
C 462.84 613.33 465.07 617.31 467.00 621.00 Z"
          />
        </g>
        <g fill="#F7D19A" fillOpacity="1.00" stroke="None">
          <path
            d="
M 271.00 644.00 
C 268.94 638.03 262.10 633.12 259.97 627.03 C 257.84 620.93 253.15 615.20 250.00 610.00
C 251.25 616.11 258.28 620.81 256.00 627.00
C 260.85 629.46 266.58 638.28 271.00 644.00 Z"
          />
        </g>
        <g fill="#F9D7A0" fillOpacity="1.00" stroke="None">
          <path
            d="
M 475.00 637.00 
C 472.73 632.04 470.76 625.84 467.00 622.00
C 469.18 627.45 472.09 632.20 475.00 637.00 Z"
          />
        </g>
        <g fill="#F4C988" fillOpacity="1.00" stroke="None">
          <path
            d="
M 344.00 625.00 
C 349.93 623.23 360.42 633.98 354.75 639.75 C 349.08 645.52 344.11 650.52 338.25 656.25 C 332.38 661.98 328.15 671.29 322.00 661.00
C 323.02 661.59 315.08 659.82 315.00 656.00
C 315.96 654.17 319.63 655.83 320.00 653.00
C 316.15 652.94 311.69 649.02 311.00 644.00
C 312.28 644.27 313.72 643.23 314.00 642.00
C 305.71 643.77 314.64 649.18 313.00 653.00
C 310.58 650.98 307.89 648.46 306.00 646.00
C 325.29 671.72 351.31 695.76 380.00 711.00
C 379.01 707.76 373.84 707.84 374.00 704.00
C 376.42 703.13 377.53 700.46 377.00 698.00
C 373.14 696.96 372.08 700.65 370.00 703.00
C 366.38 701.46 363.64 698.56 360.00 697.00
C 363.83 690.55 370.50 685.29 375.00 679.00
C 369.00 684.17 363.15 690.54 359.00 697.00
C 354.31 693.99 352.02 688.00 346.00 688.00
C 353.00 680.06 361.94 671.69 369.00 663.00
C 373.63 669.89 384.16 661.01 378.75 656.25 C 373.34 651.48 371.03 647.47 365.25 643.76 C 359.46 640.04 353.21 648.26 360.00 653.00
C 355.61 647.26 360.38 640.59 365.75 645.25 C 371.12 649.90 373.06 652.14 378.25 656.75 C 383.44 661.37 372.49 668.33 369.00 662.00
C 364.58 668.10 359.32 670.73 355.23 677.23 C 351.14 683.73 343.77 687.38 339.00 679.00
C 344.71 670.08 353.24 662.45 360.00 654.00
C 356.93 656.14 354.44 659.14 352.00 662.00
C 347.91 666.79 343.37 673.81 338.00 677.00
C 335.25 679.77 326.96 670.13 325.00 666.00
C 330.88 669.18 337.42 659.67 341.25 654.25 C 345.08 648.82 354.40 644.65 357.22 638.22 C 360.04 631.79 349.43 622.37 344.00 625.00
M 376.00 699.00 
C 375.39 701.65 373.81 705.49 371.00 706.00
C 368.60 703.14 373.39 699.41 376.00 699.00 Z"
          />
        </g>
        <g fill="#EF981F" fillOpacity="1.00" stroke="None">
          <path
            d="
M 344.00 625.00 
C 333.86 629.92 323.93 636.52 314.00 642.00
C 313.72 643.23 312.28 644.27 311.00 644.00
C 311.69 649.02 316.15 652.94 320.00 653.00
C 321.76 653.03 323.07 651.49 325.00 652.00
C 324.84 654.64 321.98 656.62 320.00 658.00
C 320.30 659.25 321.83 659.71 322.00 661.00
C 328.15 671.29 332.38 661.98 338.25 656.25 C 344.11 650.52 349.08 645.52 354.75 639.75 C 360.42 633.98 349.93 623.23 344.00 625.00
M 337.00 642.00 
C 336.83 644.27 333.65 645.48 332.00 647.00
C 329.78 643.98 335.30 643.38 337.00 642.00 Z"
          />
        </g>
        <g fill="#FAE3B6" fillOpacity="1.00" stroke="None">
          <path
            d="
M 337.00 642.00 
C 335.30 643.38 329.78 643.98 332.00 647.00
C 333.65 645.48 336.83 644.27 337.00 642.00 Z"
          />
        </g>
        <g fill="#EF981C" fillOpacity="1.00" stroke="None">
          <path
            d="
M 360.00 653.00 
C 360.00 653.00 360.20 653.60 360.00 654.00
C 353.24 662.45 344.71 670.08 339.00 679.00
C 343.77 687.38 351.14 683.73 355.23 677.23 C 359.32 670.73 364.58 668.10 369.00 662.00
C 372.49 668.33 383.44 661.37 378.25 656.75 C 373.06 652.14 371.12 649.90 365.75 645.25 C 360.38 640.59 355.61 647.26 360.00 653.00 Z"
          />
        </g>
        <g fill="#F5CA88" fillOpacity="1.00" stroke="None">
          <path
            d="
M 287.00 669.00 
C 289.55 672.11 293.36 674.91 296.00 678.00
C 306.91 690.77 319.54 702.97 332.00 713.00
C 311.00 692.00 289.70 669.34 271.00 646.00
C 272.21 653.06 282.91 663.15 287.00 669.00 Z"
          />
        </g>
        <g fill="#F6D39C" fillOpacity="1.00" stroke="None">
          <path
            d="
M 561.00 671.00 
C 558.76 664.28 555.09 657.19 553.00 651.00
C 554.63 658.35 557.63 664.82 561.00 671.00 Z"
          />
        </g>
        <g fill="#FDF6E6" fillOpacity="1.00" stroke="None">
          <path
            d="
M 320.00 653.00 
C 319.63 655.83 315.96 654.17 315.00 656.00
C 315.08 659.82 323.02 661.59 322.00 661.00
C 321.83 659.71 320.30 659.25 320.00 658.00
C 321.98 656.62 324.84 654.64 325.00 652.00
C 323.07 651.49 321.76 653.03 320.00 653.00 Z"
          />
        </g>
        <g fill="#FDEDD1" fillOpacity="1.00" stroke="None">
          <path
            d="
M 338.00 677.00 
C 343.37 673.81 347.91 666.79 352.00 662.00
C 347.64 666.36 342.77 673.48 338.00 677.00 Z"
          />
        </g>
        <g fill="#FDEED3" fillOpacity="1.00" stroke="None">
          <path
            d="
M 296.00 678.00 
C 293.36 674.91 289.55 672.11 287.00 669.00
C 289.62 672.74 292.89 675.18 296.00 678.00 Z"
          />
        </g>
        <g fill="#F6D49D" fillOpacity="1.00" stroke="None">
          <path
            d="
M 736.00 698.00 
C 739.84 696.40 746.96 694.63 749.22 690.22 C 751.48 685.81 748.43 676.46 748.00 672.00
C 748.00 676.56 750.08 686.79 748.23 690.23 C 746.38 693.67 738.98 696.34 736.00 698.00 Z"
          />
        </g>
        <g fill="#F9DEB1" fillOpacity="1.00" stroke="None">
          <path
            d="
M 517.00 695.00 
C 527.16 693.74 535.39 700.24 534.00 711.00
C 529.80 709.97 525.82 713.63 522.00 711.00
C 523.10 712.82 525.73 713.67 528.00 714.00
C 530.20 714.32 534.36 713.01 536.00 715.00
C 535.07 711.97 531.35 713.26 529.00 713.00
C 537.01 713.08 535.34 704.31 533.00 699.00
C 538.34 701.39 543.53 703.85 549.00 706.00
C 534.19 698.09 520.25 689.32 507.00 678.00
C 512.28 684.07 518.10 689.62 525.00 693.00
C 523.05 694.13 519.15 694.47 517.00 695.00 Z"
          />
        </g>
        <g fill="#F6D499" fillOpacity="1.00" stroke="None">
          <path
            d="
M 386.00 683.00 
C 383.11 684.69 380.83 687.92 380.00 691.00
C 383.82 690.71 385.13 685.99 386.00 683.00 Z"
          />
        </g>
        <g fill="#EF9B2A" fillOpacity="1.00" stroke="None">
          <path
            d="
M 406.00 720.00 
C 406.00 721.33 406.00 722.67 406.00 724.00
C 410.07 724.04 415.03 729.70 418.00 725.00
C 419.16 720.93 421.55 717.28 422.00 713.00
C 433.67 717.83 439.58 708.52 441.00 698.00 C 442.42 687.48 427.86 684.15 420.00 683.00
C 414.07 694.66 412.36 708.56 406.00 720.00
M 427.00 704.00 
C 424.81 701.56 428.03 697.73 429.00 695.00
C 431.50 697.44 428.96 702.05 427.00 704.00 Z"
          />
        </g>
        <g fill="#EF9C2C" fillOpacity="1.00" stroke="None">
          <path
            d="
M 454.00 728.00 
C 456.16 719.47 455.08 713.35 459.02 705.02 C 462.97 696.70 458.02 690.99 448.00 693.00
C 447.81 699.90 444.82 706.31 443.98 712.98 C 443.13 719.64 440.14 726.28 440.01 732.99 C 439.88 739.70 453.65 736.98 458.00 739.00
C 460.62 734.27 460.95 727.96 454.00 728.00 Z"
          />
        </g>
        <g fill="#FBE6C2" fillOpacity="1.00" stroke="None">
          <path
            d="
M 427.00 704.00 
C 428.96 702.05 431.50 697.44 429.00 695.00
C 428.03 697.73 424.81 701.56 427.00 704.00 Z"
          />
        </g>
        <g fill="#EF9B29" fillOpacity="1.00" stroke="None">
          <path
            d="
M 536.00 715.00 
C 534.36 713.01 530.20 714.32 528.00 714.00
C 526.28 714.17 523.05 715.41 521.00 716.00
C 521.33 712.17 518.17 707.23 521.00 704.00
C 521.56 706.24 522.38 708.48 522.00 711.00
C 525.82 713.63 529.80 709.97 534.00 711.00
C 535.39 700.24 527.16 693.74 517.00 695.00
C 512.19 696.19 506.93 699.11 507.00 705.00 C 507.07 710.89 507.94 716.41 509.01 721.99 C 510.08 727.58 509.64 732.12 513.25 736.75 C 516.86 741.38 523.62 739.87 527.25 738.26 C 530.89 736.65 540.75 739.09 537.99 732.01 C 535.24 724.92 539.39 720.83 536.00 715.00
M 524.00 731.00 
C 522.60 728.96 521.98 725.77 522.00 723.00
C 525.93 722.66 525.83 729.28 524.00 731.00 Z"
          />
        </g>
        <g fill="#EF9922" fillOpacity="1.00" stroke="None">
          <path
            d="
M 484.00 697.00 
C 480.00 697.00 476.00 697.00 472.00 697.00
C 473.50 710.51 462.33 741.73 484.00 742.00 C 505.67 742.26 494.82 711.31 498.00 698.00
C 486.18 694.15 485.78 702.74 486.00 711.00 C 486.21 719.25 484.63 725.49 484.00 733.00
C 480.97 721.72 485.34 709.08 484.00 697.00 Z"
          />
        </g>
        <g fill="#FDFBF1" fillOpacity="1.00" stroke="None">
          <path
            d="
M 376.00 699.00 
C 373.39 699.41 368.60 703.14 371.00 706.00
C 373.81 705.49 375.39 701.65 376.00 699.00 Z"
          />
        </g>
        <g fill="#FCF6E3" fillOpacity="1.00" stroke="None">
          <path
            d="
M 528.00 714.00 
C 525.73 713.67 523.10 712.82 522.00 711.00
C 522.38 708.48 521.56 706.24 521.00 704.00
C 518.17 707.23 521.33 712.17 521.00 716.00
C 523.05 715.41 526.28 714.17 528.00 714.00 Z"
          />
        </g>
        <g fill="#FAE2B8" fillOpacity="1.00" stroke="None">
          <path
            d="
M 398.00 721.00 
C 404.47 724.92 411.31 726.84 418.00 730.00
C 417.85 728.17 415.24 729.67 415.00 728.00
C 417.41 728.63 417.40 726.26 418.00 725.00
C 415.03 729.70 410.07 724.04 406.00 724.00
C 406.00 722.67 406.00 721.33 406.00 720.00
C 404.25 720.40 403.70 722.43 404.00 724.00
C 402.01 722.85 399.99 721.89 398.00 721.00 Z"
          />
        </g>
        <g fill="#FCEFD4" fillOpacity="1.00" stroke="None">
          <path
            d="
M 524.00 731.00 
C 525.83 729.28 525.93 722.66 522.00 723.00
C 521.98 725.77 522.60 728.96 524.00 731.00 Z"
          />
        </g>
        <g fill="#F6D39C" fillOpacity="1.00" stroke="None">
          <path
            d="
M 581.00 745.00 
C 587.33 744.47 591.78 742.64 597.00 740.00
C 593.08 740.94 585.89 743.68 581.00 745.00 Z"
          />
        </g>
        <g fill="#F5D299" fillOpacity="1.00" stroke="None">
          <path
            d="
M 540.00 751.00 
C 553.36 751.00 565.71 747.22 578.00 745.00
C 565.62 744.67 552.02 749.84 540.00 751.00 Z"
          />
        </g>
        <g fill="#F1C47C" fillOpacity="1.00" stroke="None">
          <path
            d="
M 506.00 751.00 
C 501.77 750.59 495.90 750.39 491.00 750.00
C 495.43 750.86 500.85 751.00 506.00 751.00 Z"
          />
        </g>
        <g fill="#F5D198" fillOpacity="1.00" stroke="None">
          <path
            d="
M 560.00 777.00 
C 565.98 776.33 571.63 775.33 577.00 774.00
C 571.20 774.83 565.29 775.90 560.00 777.00 Z"
          />{' '}
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
